"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IssueTokens = exports.InternalSignature = exports.IndexEntry = exports.HoldUntilOptions = exports.FeeSchedule = exports.FactomDataEntryWrapper = exports.FactomDataEntry = exports.ExpireOptions = exports.EnableAccountAuthOperation = exports.EmptyResult = exports.EcdsaSha256Signature = exports.ETHSignature = exports.ED25519Signature = exports.DoubleHashDataEntry = exports.DisableAccountAuthOperation = exports.DirectoryAnchor = exports.DelegatedSignature = exports.DataAccount = exports.CreditRecipient = exports.CreateTokenAccount = exports.CreateToken = exports.CreateLiteTokenAccount = exports.CreateKeyPage = exports.CreateKeyBook = exports.CreateIdentity = exports.CreateDataAccount = exports.ChainParams = exports.ChainMetadata = exports.BurnTokens = exports.BurnCredits = exports.BlockValidatorAnchor = exports.BlockLedger = exports.BlockEntry = exports.BTCSignature = exports.BTCLegacySignature = exports.AuthoritySignature = exports.AuthorityEntry = exports.AnnotatedReceipt = exports.AnchorMetadata = exports.AnchorLedger = exports.AddKeyOperation = exports.AddCreditsResult = exports.AddCredits = exports.AddAccountAuthorityOperation = exports.ActivateProtocolVersion = exports.AcmeOracle = exports.AcmeFaucet = exports.AccumulateDataEntry = exports.AccountAuth = exports.ADI = void 0;
exports.TokenIssuer = exports.TokenAccount = exports.SystemWriteData = exports.SystemLedger = exports.SystemGenesis = exports.SyntheticWriteData = exports.SyntheticOrigin = exports.SyntheticLedger = exports.SyntheticForwardTransaction = exports.SyntheticDepositTokens = exports.SyntheticDepositCredits = exports.SyntheticCreateIdentity = exports.SyntheticBurnTokens = exports.SignatureSet = exports.SetThresholdKeyPageOperation = exports.SetResponseThresholdKeyPageOperation = exports.SetRejectThresholdKeyPageOperation = exports.SendTokens = exports.RsaSha256Signature = exports.RoutingTable = exports.RouteOverride = exports.Route = exports.RemoveKeyOperation = exports.RemoveAccountAuthorityOperation = exports.RemoteTransaction = exports.RemoteSignature = exports.ReceiptSignature = exports.Rational = exports.RCD1Signature = exports.PendingTransactionGCOperation = exports.PartitionSyntheticLedger = exports.PartitionSignature = exports.PartitionInfo = exports.PartitionExecutorVersion = exports.PartitionAnchorReceipt = exports.PartitionAnchor = exports.NetworkMaintenance = exports.NetworkLimits = exports.NetworkGlobals = exports.NetworkDefinition = exports.NetworkAccountUpdate = exports.LockAccount = exports.LiteTokenAccount = exports.LiteIdentity = exports.LiteDataAccount = exports.LegacyED25519Signature = exports.KeySpecParams = exports.KeySpec = exports.KeyPage = exports.KeyBook = void 0;
exports.WriteDataTo = exports.WriteDataResult = exports.WriteData = exports.ValidatorPartitionInfo = exports.ValidatorInfo = exports.UpdateKeyPage = exports.UpdateKeyOperation = exports.UpdateKey = exports.UpdateAllowedKeyPageOperation = exports.UpdateAccountAuth = exports.UnknownSigner = exports.UnknownAccount = exports.TypedDataSignature = exports.TxIdSet = exports.TransferCredits = exports.TransactionStatus = exports.TransactionHeader = exports.Transaction = exports.TokenRecipient = exports.TokenIssuerProof = void 0;
const _1 = require(".");
const txid_1 = require("../address/txid");
const url_1 = require("../address/url");
const buffer_1 = require("../common/buffer");
const encoding_1 = require("../encoding");
const errors2 = __importStar(require("../errors"));
const merkle = __importStar(require("../merkle"));
const merkle_1 = require("../merkle");
const base_1 = require("./base");
class ADI {
    constructor(args) {
        this.type = _1.AccountType.Identity;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => v == undefined ? undefined : v instanceof AuthorityEntry ? v : new AuthorityEntry(v));
    }
    copy() {
        return new ADI(this.asObject());
    }
    asObject() {
        return {
            type: "identity",
            url: this.url && this.url.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], ADI.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], ADI.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).repeatable.reference
], ADI.prototype, "authorities", void 0);
exports.ADI = ADI;
class AccountAuth {
    constructor(args) {
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => v == undefined ? undefined : v instanceof AuthorityEntry ? v : new AuthorityEntry(v));
    }
    copy() {
        return new AccountAuth(this.asObject());
    }
    asObject() {
        return {
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).repeatable.reference
], AccountAuth.prototype, "authorities", void 0);
exports.AccountAuth = AccountAuth;
class AccumulateDataEntry {
    constructor(args) {
        this.type = _1.DataEntryType.Accumulate;
        this.data =
            args.data == undefined
                ? undefined
                : args.data.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new AccumulateDataEntry(this.asObject());
    }
    asObject() {
        return {
            type: "accumulate",
            data: this.data &&
                this.data?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.DataEntryType)
], AccumulateDataEntry.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.bytes
], AccumulateDataEntry.prototype, "data", void 0);
exports.AccumulateDataEntry = AccumulateDataEntry;
class AcmeFaucet {
    constructor(args) {
        this.type = _1.TransactionType.AcmeFaucet;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
    }
    copy() {
        return new AcmeFaucet(this.asObject());
    }
    asObject() {
        return {
            type: "acmeFaucet",
            url: this.url && this.url.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], AcmeFaucet.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], AcmeFaucet.prototype, "url", void 0);
exports.AcmeFaucet = AcmeFaucet;
class AcmeOracle {
    constructor(args) {
        this.price = args.price == undefined ? undefined : args.price;
    }
    copy() {
        return new AcmeOracle(this.asObject());
    }
    asObject() {
        return {
            price: this.price && this.price,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], AcmeOracle.prototype, "price", void 0);
exports.AcmeOracle = AcmeOracle;
class ActivateProtocolVersion {
    constructor(args) {
        this.type = _1.TransactionType.ActivateProtocolVersion;
        this.version = args.version == undefined ? undefined : _1.ExecutorVersion.fromObject(args.version);
    }
    copy() {
        return new ActivateProtocolVersion(this.asObject());
    }
    asObject() {
        return {
            type: "activateProtocolVersion",
            version: this.version && _1.ExecutorVersion.getName(this.version),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], ActivateProtocolVersion.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], ActivateProtocolVersion.prototype, "version", void 0);
exports.ActivateProtocolVersion = ActivateProtocolVersion;
class AddAccountAuthorityOperation {
    constructor(args) {
        this.type = _1.AccountAuthOperationType.AddAuthority;
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
    }
    copy() {
        return new AddAccountAuthorityOperation(this.asObject());
    }
    asObject() {
        return {
            type: "addAuthority",
            authority: this.authority && this.authority.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountAuthOperationType)
], AddAccountAuthorityOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], AddAccountAuthorityOperation.prototype, "authority", void 0);
exports.AddAccountAuthorityOperation = AddAccountAuthorityOperation;
class AddCredits {
    constructor(args) {
        this.type = _1.TransactionType.AddCredits;
        this.recipient = args.recipient == undefined ? undefined : url_1.AccumulateURL.parse(args.recipient);
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
        this.oracle = args.oracle == undefined ? undefined : args.oracle;
    }
    copy() {
        return new AddCredits(this.asObject());
    }
    asObject() {
        return {
            type: "addCredits",
            recipient: this.recipient && this.recipient.toString(),
            amount: this.amount && this.amount.toString(),
            oracle: this.oracle && this.oracle,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], AddCredits.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], AddCredits.prototype, "recipient", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bigInt
], AddCredits.prototype, "amount", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], AddCredits.prototype, "oracle", void 0);
exports.AddCredits = AddCredits;
class AddCreditsResult {
    constructor(args) {
        this.type = _1.TransactionType.AddCredits;
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
        this.credits = args.credits == undefined ? undefined : args.credits;
        this.oracle = args.oracle == undefined ? undefined : args.oracle;
    }
    copy() {
        return new AddCreditsResult(this.asObject());
    }
    asObject() {
        return {
            type: "addCredits",
            amount: this.amount && this.amount.toString(),
            credits: this.credits && this.credits,
            oracle: this.oracle && this.oracle,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], AddCreditsResult.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bigInt
], AddCreditsResult.prototype, "amount", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], AddCreditsResult.prototype, "credits", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], AddCreditsResult.prototype, "oracle", void 0);
exports.AddCreditsResult = AddCreditsResult;
class AddKeyOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.Add;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof KeySpecParams
                    ? args.entry
                    : new KeySpecParams(args.entry);
    }
    copy() {
        return new AddKeyOperation(this.asObject());
    }
    asObject() {
        return {
            type: "add",
            entry: this.entry && this.entry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], AddKeyOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], AddKeyOperation.prototype, "entry", void 0);
exports.AddKeyOperation = AddKeyOperation;
class AnchorLedger {
    constructor(args) {
        this.type = _1.AccountType.AnchorLedger;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.minorBlockSequenceNumber =
            args.minorBlockSequenceNumber == undefined ? undefined : args.minorBlockSequenceNumber;
        this.majorBlockIndex = args.majorBlockIndex == undefined ? undefined : args.majorBlockIndex;
        this.majorBlockTime =
            args.majorBlockTime == undefined
                ? undefined
                : args.majorBlockTime instanceof Date
                    ? args.majorBlockTime
                    : new Date(args.majorBlockTime);
        this.pendingMajorBlockAnchors =
            args.pendingMajorBlockAnchors == undefined
                ? undefined
                : args.pendingMajorBlockAnchors.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
        this.sequence =
            args.sequence == undefined
                ? undefined
                : args.sequence.map((v) => v == undefined
                    ? undefined
                    : v instanceof PartitionSyntheticLedger
                        ? v
                        : new PartitionSyntheticLedger(v));
    }
    copy() {
        return new AnchorLedger(this.asObject());
    }
    asObject() {
        return {
            type: "anchorLedger",
            url: this.url && this.url.toString(),
            minorBlockSequenceNumber: this.minorBlockSequenceNumber && this.minorBlockSequenceNumber,
            majorBlockIndex: this.majorBlockIndex && this.majorBlockIndex,
            majorBlockTime: this.majorBlockTime && this.majorBlockTime,
            pendingMajorBlockAnchors: this.pendingMajorBlockAnchors &&
                this.pendingMajorBlockAnchors?.map((v) => (v == undefined ? undefined : v.toString())),
            sequence: this.sequence && this.sequence?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], AnchorLedger.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], AnchorLedger.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], AnchorLedger.prototype, "minorBlockSequenceNumber", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], AnchorLedger.prototype, "majorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(5).time
], AnchorLedger.prototype, "majorBlockTime", void 0);
__decorate([
    encoding_1.encodeAs.field(6).repeatable.url
], AnchorLedger.prototype, "pendingMajorBlockAnchors", void 0);
__decorate([
    encoding_1.encodeAs.field(7).repeatable.reference
], AnchorLedger.prototype, "sequence", void 0);
exports.AnchorLedger = AnchorLedger;
class AnchorMetadata {
    constructor(args) {
        this.name = args.name == undefined ? undefined : args.name;
        this.type = args.type == undefined ? undefined : merkle_1.ChainType.fromObject(args.type);
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
        this.index = args.index == undefined ? undefined : args.index;
        this.sourceIndex = args.sourceIndex == undefined ? undefined : args.sourceIndex;
        this.sourceBlock = args.sourceBlock == undefined ? undefined : args.sourceBlock;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof Uint8Array
                    ? args.entry
                    : buffer_1.Buffer.from(args.entry, "hex");
    }
    copy() {
        return new AnchorMetadata(this.asObject());
    }
    asObject() {
        return {
            name: this.name && this.name,
            type: this.type && merkle_1.ChainType.getName(this.type),
            account: this.account && this.account.toString(),
            index: this.index && this.index,
            sourceIndex: this.sourceIndex && this.sourceIndex,
            sourceBlock: this.sourceBlock && this.sourceBlock,
            entry: this.entry && this.entry && buffer_1.Buffer.from(this.entry).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1, 1).string
], AnchorMetadata.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(1, 2).enum
], AnchorMetadata.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], AnchorMetadata.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], AnchorMetadata.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], AnchorMetadata.prototype, "sourceIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], AnchorMetadata.prototype, "sourceBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(6).bytes
], AnchorMetadata.prototype, "entry", void 0);
exports.AnchorMetadata = AnchorMetadata;
class AnnotatedReceipt {
    constructor(args) {
        this.receipt =
            args.receipt == undefined
                ? undefined
                : args.receipt instanceof merkle.Receipt
                    ? args.receipt
                    : new merkle.Receipt(args.receipt);
        this.anchor =
            args.anchor == undefined
                ? undefined
                : args.anchor instanceof AnchorMetadata
                    ? args.anchor
                    : new AnchorMetadata(args.anchor);
    }
    copy() {
        return new AnnotatedReceipt(this.asObject());
    }
    asObject() {
        return {
            receipt: this.receipt && this.receipt.asObject(),
            anchor: this.anchor && this.anchor.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], AnnotatedReceipt.prototype, "receipt", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], AnnotatedReceipt.prototype, "anchor", void 0);
exports.AnnotatedReceipt = AnnotatedReceipt;
class AuthorityEntry {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.disabled = args.disabled == undefined ? undefined : args.disabled;
    }
    copy() {
        return new AuthorityEntry(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            disabled: this.disabled && this.disabled,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], AuthorityEntry.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bool
], AuthorityEntry.prototype, "disabled", void 0);
exports.AuthorityEntry = AuthorityEntry;
class AuthoritySignature {
    constructor(args) {
        this.type = _1.SignatureType.Authority;
        this.origin = args.origin == undefined ? undefined : url_1.AccumulateURL.parse(args.origin);
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.txID = args.txID == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txID);
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.delegator =
            args.delegator == undefined
                ? undefined
                : args.delegator.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
        this.memo = args.memo == undefined ? undefined : args.memo;
    }
    copy() {
        return new AuthoritySignature(this.asObject());
    }
    asObject() {
        return {
            type: "authority",
            origin: this.origin && this.origin.toString(),
            authority: this.authority && this.authority.toString(),
            vote: this.vote && _1.VoteType.getName(this.vote),
            txID: this.txID && this.txID.toString(),
            cause: this.cause && this.cause.toString(),
            delegator: this.delegator && this.delegator?.map((v) => (v == undefined ? undefined : v.toString())),
            memo: this.memo && this.memo,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], AuthoritySignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], AuthoritySignature.prototype, "origin", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], AuthoritySignature.prototype, "authority", void 0);
__decorate([
    encoding_1.encodeAs.field(4).enum
], AuthoritySignature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(5).txid
], AuthoritySignature.prototype, "txID", void 0);
__decorate([
    encoding_1.encodeAs.field(6).txid
], AuthoritySignature.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(7).repeatable.url
], AuthoritySignature.prototype, "delegator", void 0);
__decorate([
    encoding_1.encodeAs.field(8).string
], AuthoritySignature.prototype, "memo", void 0);
exports.AuthoritySignature = AuthoritySignature;
class BTCLegacySignature {
    constructor(args) {
        this.type = _1.SignatureType.BTCLegacy;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new BTCLegacySignature(this.asObject());
    }
    asObject() {
        return {
            type: "btclegacy",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], BTCLegacySignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], BTCLegacySignature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], BTCLegacySignature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], BTCLegacySignature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], BTCLegacySignature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], BTCLegacySignature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], BTCLegacySignature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], BTCLegacySignature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], BTCLegacySignature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], BTCLegacySignature.prototype, "data", void 0);
exports.BTCLegacySignature = BTCLegacySignature;
class BTCSignature {
    constructor(args) {
        this.type = _1.SignatureType.BTC;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new BTCSignature(this.asObject());
    }
    asObject() {
        return {
            type: "btc",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], BTCSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], BTCSignature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], BTCSignature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], BTCSignature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], BTCSignature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], BTCSignature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], BTCSignature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], BTCSignature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], BTCSignature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], BTCSignature.prototype, "data", void 0);
exports.BTCSignature = BTCSignature;
class BlockEntry {
    constructor(args) {
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
        this.chain = args.chain == undefined ? undefined : args.chain;
        this.index = args.index == undefined ? undefined : args.index;
    }
    copy() {
        return new BlockEntry(this.asObject());
    }
    asObject() {
        return {
            account: this.account && this.account.toString(),
            chain: this.chain && this.chain,
            index: this.index && this.index,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], BlockEntry.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], BlockEntry.prototype, "chain", void 0);
__decorate([
    encoding_1.encodeAs.field(3).keepEmpty.uint
], BlockEntry.prototype, "index", void 0);
exports.BlockEntry = BlockEntry;
class BlockLedger {
    constructor(args) {
        this.type = _1.AccountType.BlockLedger;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.index = args.index == undefined ? undefined : args.index;
        this.time =
            args.time == undefined
                ? undefined
                : args.time instanceof Date
                    ? args.time
                    : new Date(args.time);
        this.entries =
            args.entries == undefined
                ? undefined
                : args.entries.map((v) => v == undefined ? undefined : v instanceof BlockEntry ? v : new BlockEntry(v));
    }
    copy() {
        return new BlockLedger(this.asObject());
    }
    asObject() {
        return {
            type: "blockLedger",
            url: this.url && this.url.toString(),
            index: this.index && this.index,
            time: this.time && this.time,
            entries: this.entries && this.entries?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], BlockLedger.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], BlockLedger.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], BlockLedger.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(4).time
], BlockLedger.prototype, "time", void 0);
__decorate([
    encoding_1.encodeAs.field(5).repeatable.reference
], BlockLedger.prototype, "entries", void 0);
exports.BlockLedger = BlockLedger;
class BlockValidatorAnchor {
    constructor(args) {
        this.type = _1.TransactionType.BlockValidatorAnchor;
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.majorBlockIndex = args.majorBlockIndex == undefined ? undefined : args.majorBlockIndex;
        this.minorBlockIndex = args.minorBlockIndex == undefined ? undefined : args.minorBlockIndex;
        this.rootChainIndex = args.rootChainIndex == undefined ? undefined : args.rootChainIndex;
        this.rootChainAnchor =
            args.rootChainAnchor == undefined
                ? undefined
                : args.rootChainAnchor instanceof Uint8Array
                    ? args.rootChainAnchor
                    : buffer_1.Buffer.from(args.rootChainAnchor, "hex");
        this.stateTreeAnchor =
            args.stateTreeAnchor == undefined
                ? undefined
                : args.stateTreeAnchor instanceof Uint8Array
                    ? args.stateTreeAnchor
                    : buffer_1.Buffer.from(args.stateTreeAnchor, "hex");
        this.acmeBurnt =
            args.acmeBurnt == undefined
                ? undefined
                : typeof args.acmeBurnt === "bigint"
                    ? args.acmeBurnt
                    : BigInt(args.acmeBurnt);
    }
    copy() {
        return new BlockValidatorAnchor(this.asObject());
    }
    asObject() {
        return {
            type: "blockValidatorAnchor",
            source: this.source && this.source.toString(),
            majorBlockIndex: this.majorBlockIndex && this.majorBlockIndex,
            minorBlockIndex: this.minorBlockIndex && this.minorBlockIndex,
            rootChainIndex: this.rootChainIndex && this.rootChainIndex,
            rootChainAnchor: this.rootChainAnchor &&
                this.rootChainAnchor &&
                buffer_1.Buffer.from(this.rootChainAnchor).toString("hex"),
            stateTreeAnchor: this.stateTreeAnchor &&
                this.stateTreeAnchor &&
                buffer_1.Buffer.from(this.stateTreeAnchor).toString("hex"),
            acmeBurnt: this.acmeBurnt && this.acmeBurnt.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], BlockValidatorAnchor.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).url
], BlockValidatorAnchor.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 2).uint
], BlockValidatorAnchor.prototype, "majorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).uint
], BlockValidatorAnchor.prototype, "minorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], BlockValidatorAnchor.prototype, "rootChainIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).hash
], BlockValidatorAnchor.prototype, "rootChainAnchor", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 6).hash
], BlockValidatorAnchor.prototype, "stateTreeAnchor", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bigInt
], BlockValidatorAnchor.prototype, "acmeBurnt", void 0);
exports.BlockValidatorAnchor = BlockValidatorAnchor;
class BurnCredits {
    constructor(args) {
        this.type = _1.TransactionType.BurnCredits;
        this.amount = args.amount == undefined ? undefined : args.amount;
    }
    copy() {
        return new BurnCredits(this.asObject());
    }
    asObject() {
        return {
            type: "burnCredits",
            amount: this.amount && this.amount,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], BurnCredits.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], BurnCredits.prototype, "amount", void 0);
exports.BurnCredits = BurnCredits;
class BurnTokens {
    constructor(args) {
        this.type = _1.TransactionType.BurnTokens;
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
    }
    copy() {
        return new BurnTokens(this.asObject());
    }
    asObject() {
        return {
            type: "burnTokens",
            amount: this.amount && this.amount.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], BurnTokens.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bigInt
], BurnTokens.prototype, "amount", void 0);
exports.BurnTokens = BurnTokens;
class ChainMetadata {
    constructor(args) {
        this.name = args.name == undefined ? undefined : args.name;
        this.type = args.type == undefined ? undefined : merkle_1.ChainType.fromObject(args.type);
    }
    copy() {
        return new ChainMetadata(this.asObject());
    }
    asObject() {
        return {
            name: this.name && this.name,
            type: this.type && merkle_1.ChainType.getName(this.type),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], ChainMetadata.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], ChainMetadata.prototype, "type", void 0);
exports.ChainMetadata = ChainMetadata;
class ChainParams {
    constructor(args) {
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
        this.isUpdate = args.isUpdate == undefined ? undefined : args.isUpdate;
    }
    copy() {
        return new ChainParams(this.asObject());
    }
    asObject() {
        return {
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
            isUpdate: this.isUpdate && this.isUpdate,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bytes
], ChainParams.prototype, "data", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bool
], ChainParams.prototype, "isUpdate", void 0);
exports.ChainParams = ChainParams;
class CreateDataAccount {
    constructor(args) {
        this.type = _1.TransactionType.CreateDataAccount;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
    }
    copy() {
        return new CreateDataAccount(this.asObject());
    }
    asObject() {
        return {
            type: "createDataAccount",
            url: this.url && this.url.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateDataAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], CreateDataAccount.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.url
], CreateDataAccount.prototype, "authorities", void 0);
exports.CreateDataAccount = CreateDataAccount;
class CreateIdentity {
    constructor(args) {
        this.type = _1.TransactionType.CreateIdentity;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.keyHash =
            args.keyHash == undefined
                ? undefined
                : args.keyHash instanceof Uint8Array
                    ? args.keyHash
                    : buffer_1.Buffer.from(args.keyHash, "hex");
        this.keyBookUrl = args.keyBookUrl == undefined ? undefined : url_1.AccumulateURL.parse(args.keyBookUrl);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
    }
    copy() {
        return new CreateIdentity(this.asObject());
    }
    asObject() {
        return {
            type: "createIdentity",
            url: this.url && this.url.toString(),
            keyHash: this.keyHash && this.keyHash && buffer_1.Buffer.from(this.keyHash).toString("hex"),
            keyBookUrl: this.keyBookUrl && this.keyBookUrl.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateIdentity.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], CreateIdentity.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], CreateIdentity.prototype, "keyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], CreateIdentity.prototype, "keyBookUrl", void 0);
__decorate([
    encoding_1.encodeAs.field(6).repeatable.url
], CreateIdentity.prototype, "authorities", void 0);
exports.CreateIdentity = CreateIdentity;
class CreateKeyBook {
    constructor(args) {
        this.type = _1.TransactionType.CreateKeyBook;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.publicKeyHash =
            args.publicKeyHash == undefined
                ? undefined
                : args.publicKeyHash instanceof Uint8Array
                    ? args.publicKeyHash
                    : buffer_1.Buffer.from(args.publicKeyHash, "hex");
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
    }
    copy() {
        return new CreateKeyBook(this.asObject());
    }
    asObject() {
        return {
            type: "createKeyBook",
            url: this.url && this.url.toString(),
            publicKeyHash: this.publicKeyHash && this.publicKeyHash && buffer_1.Buffer.from(this.publicKeyHash).toString("hex"),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateKeyBook.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], CreateKeyBook.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], CreateKeyBook.prototype, "publicKeyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(5).repeatable.url
], CreateKeyBook.prototype, "authorities", void 0);
exports.CreateKeyBook = CreateKeyBook;
class CreateKeyPage {
    constructor(args) {
        this.type = _1.TransactionType.CreateKeyPage;
        this.keys =
            args.keys == undefined
                ? undefined
                : args.keys.map((v) => v == undefined ? undefined : v instanceof KeySpecParams ? v : new KeySpecParams(v));
    }
    copy() {
        return new CreateKeyPage(this.asObject());
    }
    asObject() {
        return {
            type: "createKeyPage",
            keys: this.keys && this.keys?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateKeyPage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.reference
], CreateKeyPage.prototype, "keys", void 0);
exports.CreateKeyPage = CreateKeyPage;
class CreateLiteTokenAccount {
    constructor(_) {
        this.type = _1.TransactionType.CreateLiteTokenAccount;
    }
    copy() {
        return new CreateLiteTokenAccount(this.asObject());
    }
    asObject() {
        return {
            type: "createLiteTokenAccount",
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateLiteTokenAccount.prototype, "type", void 0);
exports.CreateLiteTokenAccount = CreateLiteTokenAccount;
class CreateToken {
    constructor(args) {
        this.type = _1.TransactionType.CreateToken;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.symbol = args.symbol == undefined ? undefined : args.symbol;
        this.precision = args.precision == undefined ? undefined : args.precision;
        this.properties = args.properties == undefined ? undefined : url_1.AccumulateURL.parse(args.properties);
        this.supplyLimit =
            args.supplyLimit == undefined
                ? undefined
                : typeof args.supplyLimit === "bigint"
                    ? args.supplyLimit
                    : BigInt(args.supplyLimit);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
    }
    copy() {
        return new CreateToken(this.asObject());
    }
    asObject() {
        return {
            type: "createToken",
            url: this.url && this.url.toString(),
            symbol: this.symbol && this.symbol,
            precision: this.precision && this.precision,
            properties: this.properties && this.properties.toString(),
            supplyLimit: this.supplyLimit && this.supplyLimit.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateToken.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], CreateToken.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(4).string
], CreateToken.prototype, "symbol", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], CreateToken.prototype, "precision", void 0);
__decorate([
    encoding_1.encodeAs.field(6).url
], CreateToken.prototype, "properties", void 0);
__decorate([
    encoding_1.encodeAs.field(7).bigInt
], CreateToken.prototype, "supplyLimit", void 0);
__decorate([
    encoding_1.encodeAs.field(9).repeatable.url
], CreateToken.prototype, "authorities", void 0);
exports.CreateToken = CreateToken;
class CreateTokenAccount {
    constructor(args) {
        this.type = _1.TransactionType.CreateTokenAccount;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.tokenUrl = args.tokenUrl == undefined ? undefined : url_1.AccumulateURL.parse(args.tokenUrl);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof TokenIssuerProof
                    ? args.proof
                    : new TokenIssuerProof(args.proof);
    }
    copy() {
        return new CreateTokenAccount(this.asObject());
    }
    asObject() {
        return {
            type: "createTokenAccount",
            url: this.url && this.url.toString(),
            tokenUrl: this.tokenUrl && this.tokenUrl.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.toString())),
            proof: this.proof && this.proof.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], CreateTokenAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], CreateTokenAccount.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], CreateTokenAccount.prototype, "tokenUrl", void 0);
__decorate([
    encoding_1.encodeAs.field(7).repeatable.url
], CreateTokenAccount.prototype, "authorities", void 0);
__decorate([
    encoding_1.encodeAs.field(8).reference
], CreateTokenAccount.prototype, "proof", void 0);
exports.CreateTokenAccount = CreateTokenAccount;
class CreditRecipient {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.amount = args.amount == undefined ? undefined : args.amount;
    }
    copy() {
        return new CreditRecipient(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            amount: this.amount && this.amount,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], CreditRecipient.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], CreditRecipient.prototype, "amount", void 0);
exports.CreditRecipient = CreditRecipient;
class DataAccount {
    constructor(args) {
        this.type = _1.AccountType.DataAccount;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => v == undefined ? undefined : v instanceof AuthorityEntry ? v : new AuthorityEntry(v));
        this.entry = args.entry == undefined ? undefined : _1.DataEntry.fromObject(args.entry);
    }
    copy() {
        return new DataAccount(this.asObject());
    }
    asObject() {
        return {
            type: "dataAccount",
            url: this.url && this.url.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.asObject())),
            entry: this.entry && this.entry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], DataAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], DataAccount.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).repeatable.reference
], DataAccount.prototype, "authorities", void 0);
__decorate([
    encoding_1.encodeAs.field(4).union
], DataAccount.prototype, "entry", void 0);
exports.DataAccount = DataAccount;
class DelegatedSignature {
    constructor(args) {
        this.type = _1.SignatureType.Delegated;
        this.signature = args.signature == undefined ? undefined : _1.Signature.fromObject(args.signature);
        this.delegator = args.delegator == undefined ? undefined : url_1.AccumulateURL.parse(args.delegator);
    }
    copy() {
        return new DelegatedSignature(this.asObject());
    }
    asObject() {
        return {
            type: "delegated",
            signature: this.signature && this.signature.asObject(),
            delegator: this.delegator && this.delegator.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], DelegatedSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], DelegatedSignature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], DelegatedSignature.prototype, "delegator", void 0);
exports.DelegatedSignature = DelegatedSignature;
class DirectoryAnchor {
    constructor(args) {
        this.type = _1.TransactionType.DirectoryAnchor;
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.majorBlockIndex = args.majorBlockIndex == undefined ? undefined : args.majorBlockIndex;
        this.minorBlockIndex = args.minorBlockIndex == undefined ? undefined : args.minorBlockIndex;
        this.rootChainIndex = args.rootChainIndex == undefined ? undefined : args.rootChainIndex;
        this.rootChainAnchor =
            args.rootChainAnchor == undefined
                ? undefined
                : args.rootChainAnchor instanceof Uint8Array
                    ? args.rootChainAnchor
                    : buffer_1.Buffer.from(args.rootChainAnchor, "hex");
        this.stateTreeAnchor =
            args.stateTreeAnchor == undefined
                ? undefined
                : args.stateTreeAnchor instanceof Uint8Array
                    ? args.stateTreeAnchor
                    : buffer_1.Buffer.from(args.stateTreeAnchor, "hex");
        this.updates =
            args.updates == undefined
                ? undefined
                : args.updates.map((v) => v == undefined
                    ? undefined
                    : v instanceof NetworkAccountUpdate
                        ? v
                        : new NetworkAccountUpdate(v));
        this.receipts =
            args.receipts == undefined
                ? undefined
                : args.receipts.map((v) => v == undefined
                    ? undefined
                    : v instanceof PartitionAnchorReceipt
                        ? v
                        : new PartitionAnchorReceipt(v));
        this.makeMajorBlock = args.makeMajorBlock == undefined ? undefined : args.makeMajorBlock;
        this.makeMajorBlockTime =
            args.makeMajorBlockTime == undefined
                ? undefined
                : args.makeMajorBlockTime instanceof Date
                    ? args.makeMajorBlockTime
                    : new Date(args.makeMajorBlockTime);
    }
    copy() {
        return new DirectoryAnchor(this.asObject());
    }
    asObject() {
        return {
            type: "directoryAnchor",
            source: this.source && this.source.toString(),
            majorBlockIndex: this.majorBlockIndex && this.majorBlockIndex,
            minorBlockIndex: this.minorBlockIndex && this.minorBlockIndex,
            rootChainIndex: this.rootChainIndex && this.rootChainIndex,
            rootChainAnchor: this.rootChainAnchor &&
                this.rootChainAnchor &&
                buffer_1.Buffer.from(this.rootChainAnchor).toString("hex"),
            stateTreeAnchor: this.stateTreeAnchor &&
                this.stateTreeAnchor &&
                buffer_1.Buffer.from(this.stateTreeAnchor).toString("hex"),
            updates: this.updates && this.updates?.map((v) => (v == undefined ? undefined : v.asObject())),
            receipts: this.receipts && this.receipts?.map((v) => (v == undefined ? undefined : v.asObject())),
            makeMajorBlock: this.makeMajorBlock && this.makeMajorBlock,
            makeMajorBlockTime: this.makeMajorBlockTime && this.makeMajorBlockTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], DirectoryAnchor.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).url
], DirectoryAnchor.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 2).uint
], DirectoryAnchor.prototype, "majorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).uint
], DirectoryAnchor.prototype, "minorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], DirectoryAnchor.prototype, "rootChainIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).hash
], DirectoryAnchor.prototype, "rootChainAnchor", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 6).hash
], DirectoryAnchor.prototype, "stateTreeAnchor", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.reference
], DirectoryAnchor.prototype, "updates", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], DirectoryAnchor.prototype, "receipts", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], DirectoryAnchor.prototype, "makeMajorBlock", void 0);
__decorate([
    encoding_1.encodeAs.field(6).time
], DirectoryAnchor.prototype, "makeMajorBlockTime", void 0);
exports.DirectoryAnchor = DirectoryAnchor;
class DisableAccountAuthOperation {
    constructor(args) {
        this.type = _1.AccountAuthOperationType.Disable;
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
    }
    copy() {
        return new DisableAccountAuthOperation(this.asObject());
    }
    asObject() {
        return {
            type: "disable",
            authority: this.authority && this.authority.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountAuthOperationType)
], DisableAccountAuthOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], DisableAccountAuthOperation.prototype, "authority", void 0);
exports.DisableAccountAuthOperation = DisableAccountAuthOperation;
class DoubleHashDataEntry {
    constructor(args) {
        this.type = _1.DataEntryType.DoubleHash;
        this.data =
            args.data == undefined
                ? undefined
                : args.data.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new DoubleHashDataEntry(this.asObject());
    }
    asObject() {
        return {
            type: "doubleHash",
            data: this.data &&
                this.data?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.DataEntryType)
], DoubleHashDataEntry.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.bytes
], DoubleHashDataEntry.prototype, "data", void 0);
exports.DoubleHashDataEntry = DoubleHashDataEntry;
class ED25519Signature {
    constructor(args) {
        this.type = _1.SignatureType.ED25519;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new ED25519Signature(this.asObject());
    }
    asObject() {
        return {
            type: "ed25519",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], ED25519Signature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], ED25519Signature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], ED25519Signature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], ED25519Signature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], ED25519Signature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], ED25519Signature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], ED25519Signature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], ED25519Signature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], ED25519Signature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], ED25519Signature.prototype, "data", void 0);
exports.ED25519Signature = ED25519Signature;
class ETHSignature {
    constructor(args) {
        this.type = _1.SignatureType.ETH;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new ETHSignature(this.asObject());
    }
    asObject() {
        return {
            type: "eth",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], ETHSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], ETHSignature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], ETHSignature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], ETHSignature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], ETHSignature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], ETHSignature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], ETHSignature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], ETHSignature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], ETHSignature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], ETHSignature.prototype, "data", void 0);
exports.ETHSignature = ETHSignature;
class EcdsaSha256Signature {
    constructor(args) {
        this.type = _1.SignatureType.EcdsaSha256;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new EcdsaSha256Signature(this.asObject());
    }
    asObject() {
        return {
            type: "ecdsaSha256",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], EcdsaSha256Signature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], EcdsaSha256Signature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], EcdsaSha256Signature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], EcdsaSha256Signature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], EcdsaSha256Signature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], EcdsaSha256Signature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], EcdsaSha256Signature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], EcdsaSha256Signature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], EcdsaSha256Signature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], EcdsaSha256Signature.prototype, "data", void 0);
exports.EcdsaSha256Signature = EcdsaSha256Signature;
class EmptyResult {
    constructor(_) {
        this.type = _1.TransactionType.Unknown;
    }
    copy() {
        return new EmptyResult(this.asObject());
    }
    asObject() {
        return {
            type: "unknown",
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], EmptyResult.prototype, "type", void 0);
exports.EmptyResult = EmptyResult;
class EnableAccountAuthOperation {
    constructor(args) {
        this.type = _1.AccountAuthOperationType.Enable;
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
    }
    copy() {
        return new EnableAccountAuthOperation(this.asObject());
    }
    asObject() {
        return {
            type: "enable",
            authority: this.authority && this.authority.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountAuthOperationType)
], EnableAccountAuthOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], EnableAccountAuthOperation.prototype, "authority", void 0);
exports.EnableAccountAuthOperation = EnableAccountAuthOperation;
class ExpireOptions {
    constructor(args) {
        this.atTime =
            args.atTime == undefined
                ? undefined
                : args.atTime instanceof Date
                    ? args.atTime
                    : new Date(args.atTime);
    }
    copy() {
        return new ExpireOptions(this.asObject());
    }
    asObject() {
        return {
            atTime: this.atTime && this.atTime,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).time
], ExpireOptions.prototype, "atTime", void 0);
exports.ExpireOptions = ExpireOptions;
class FactomDataEntry {
    constructor(args) {
        this.accountId =
            args.accountId == undefined
                ? undefined
                : args.accountId instanceof Uint8Array
                    ? args.accountId
                    : buffer_1.Buffer.from(args.accountId, "hex");
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
        this.extIds =
            args.extIds == undefined
                ? undefined
                : args.extIds.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new FactomDataEntry(this.asObject());
    }
    asObject() {
        return {
            accountId: this.accountId && this.accountId && buffer_1.Buffer.from(this.accountId).toString("hex"),
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
            extIds: this.extIds &&
                this.extIds?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
exports.FactomDataEntry = FactomDataEntry;
class FactomDataEntryWrapper {
    constructor(args) {
        this.type = _1.DataEntryType.Factom;
        this.accountId =
            args.accountId == undefined
                ? undefined
                : args.accountId instanceof Uint8Array
                    ? args.accountId
                    : buffer_1.Buffer.from(args.accountId, "hex");
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
        this.extIds =
            args.extIds == undefined
                ? undefined
                : args.extIds.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new FactomDataEntryWrapper(this.asObject());
    }
    asObject() {
        return {
            type: "factom",
            accountId: this.accountId && this.accountId && buffer_1.Buffer.from(this.accountId).toString("hex"),
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
            extIds: this.extIds &&
                this.extIds?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.DataEntryType)
], FactomDataEntryWrapper.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).hash
], FactomDataEntryWrapper.prototype, "accountId", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 2).bytes
], FactomDataEntryWrapper.prototype, "data", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).repeatable.bytes
], FactomDataEntryWrapper.prototype, "extIds", void 0);
exports.FactomDataEntryWrapper = FactomDataEntryWrapper;
class FeeSchedule {
    constructor(args) {
        this.createIdentitySliding =
            args.createIdentitySliding == undefined
                ? undefined
                : args.createIdentitySliding.map((v) => (v == undefined ? undefined : _1.Fee.fromObject(v)));
        this.createSubIdentity =
            args.createSubIdentity == undefined ? undefined : _1.Fee.fromObject(args.createSubIdentity);
        this.bareIdentityDiscount =
            args.bareIdentityDiscount == undefined
                ? undefined
                : _1.Fee.fromObject(args.bareIdentityDiscount);
    }
    copy() {
        return new FeeSchedule(this.asObject());
    }
    asObject() {
        return {
            createIdentitySliding: this.createIdentitySliding &&
                this.createIdentitySliding?.map((v) => (v == undefined ? undefined : _1.Fee.getName(v))),
            createSubIdentity: this.createSubIdentity && _1.Fee.getName(this.createSubIdentity),
            bareIdentityDiscount: this.bareIdentityDiscount && _1.Fee.getName(this.bareIdentityDiscount),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).repeatable.enum
], FeeSchedule.prototype, "createIdentitySliding", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], FeeSchedule.prototype, "createSubIdentity", void 0);
__decorate([
    encoding_1.encodeAs.field(3).enum
], FeeSchedule.prototype, "bareIdentityDiscount", void 0);
exports.FeeSchedule = FeeSchedule;
class HoldUntilOptions {
    constructor(args) {
        this.minorBlock = args.minorBlock == undefined ? undefined : args.minorBlock;
    }
    copy() {
        return new HoldUntilOptions(this.asObject());
    }
    asObject() {
        return {
            minorBlock: this.minorBlock && this.minorBlock,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], HoldUntilOptions.prototype, "minorBlock", void 0);
exports.HoldUntilOptions = HoldUntilOptions;
class IndexEntry {
    constructor(args) {
        this.source = args.source == undefined ? undefined : args.source;
        this.anchor = args.anchor == undefined ? undefined : args.anchor;
        this.blockIndex = args.blockIndex == undefined ? undefined : args.blockIndex;
        this.blockTime =
            args.blockTime == undefined
                ? undefined
                : args.blockTime instanceof Date
                    ? args.blockTime
                    : new Date(args.blockTime);
        this.rootIndexIndex = args.rootIndexIndex == undefined ? undefined : args.rootIndexIndex;
    }
    copy() {
        return new IndexEntry(this.asObject());
    }
    asObject() {
        return {
            source: this.source && this.source,
            anchor: this.anchor && this.anchor,
            blockIndex: this.blockIndex && this.blockIndex,
            blockTime: this.blockTime && this.blockTime,
            rootIndexIndex: this.rootIndexIndex && this.rootIndexIndex,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], IndexEntry.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], IndexEntry.prototype, "anchor", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], IndexEntry.prototype, "blockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(4).time
], IndexEntry.prototype, "blockTime", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], IndexEntry.prototype, "rootIndexIndex", void 0);
exports.IndexEntry = IndexEntry;
class InternalSignature {
    constructor(args) {
        this.type = _1.SignatureType.Internal;
        this.cause =
            args.cause == undefined
                ? undefined
                : args.cause instanceof Uint8Array
                    ? args.cause
                    : buffer_1.Buffer.from(args.cause, "hex");
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
    }
    copy() {
        return new InternalSignature(this.asObject());
    }
    asObject() {
        return {
            type: "internal",
            cause: this.cause && this.cause && buffer_1.Buffer.from(this.cause).toString("hex"),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], InternalSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], InternalSignature.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(3).hash
], InternalSignature.prototype, "transactionHash", void 0);
exports.InternalSignature = InternalSignature;
class IssueTokens {
    constructor(args) {
        this.type = _1.TransactionType.IssueTokens;
        this.recipient = args.recipient == undefined ? undefined : url_1.AccumulateURL.parse(args.recipient);
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
        this.to =
            args.to == undefined
                ? undefined
                : args.to.map((v) => v == undefined ? undefined : v instanceof TokenRecipient ? v : new TokenRecipient(v));
    }
    copy() {
        return new IssueTokens(this.asObject());
    }
    asObject() {
        return {
            type: "issueTokens",
            recipient: this.recipient && this.recipient.toString(),
            amount: this.amount && this.amount.toString(),
            to: this.to && this.to?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], IssueTokens.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], IssueTokens.prototype, "recipient", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bigInt
], IssueTokens.prototype, "amount", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], IssueTokens.prototype, "to", void 0);
exports.IssueTokens = IssueTokens;
class KeyBook {
    constructor(args) {
        this.type = _1.AccountType.KeyBook;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.bookType = args.bookType == undefined ? undefined : _1.BookType.fromObject(args.bookType);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => v == undefined ? undefined : v instanceof AuthorityEntry ? v : new AuthorityEntry(v));
        this.pageCount = args.pageCount == undefined ? undefined : args.pageCount;
    }
    copy() {
        return new KeyBook(this.asObject());
    }
    asObject() {
        return {
            type: "keyBook",
            url: this.url && this.url.toString(),
            bookType: this.bookType && _1.BookType.getName(this.bookType),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.asObject())),
            pageCount: this.pageCount && this.pageCount,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], KeyBook.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], KeyBook.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).enum
], KeyBook.prototype, "bookType", void 0);
__decorate([
    encoding_1.encodeAs.field(4, 1).repeatable.reference
], KeyBook.prototype, "authorities", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], KeyBook.prototype, "pageCount", void 0);
exports.KeyBook = KeyBook;
class KeyPage {
    constructor(args) {
        this.type = _1.AccountType.KeyPage;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.creditBalance = args.creditBalance == undefined ? undefined : args.creditBalance;
        this.acceptThreshold = args.acceptThreshold == undefined ? undefined : args.acceptThreshold;
        this.rejectThreshold = args.rejectThreshold == undefined ? undefined : args.rejectThreshold;
        this.responseThreshold =
            args.responseThreshold == undefined ? undefined : args.responseThreshold;
        this.blockThreshold = args.blockThreshold == undefined ? undefined : args.blockThreshold;
        this.version = args.version == undefined ? undefined : args.version;
        this.keys =
            args.keys == undefined
                ? undefined
                : args.keys.map((v) => v == undefined ? undefined : v instanceof KeySpec ? v : new KeySpec(v));
        this.transactionBlacklist =
            args.transactionBlacklist == undefined
                ? undefined
                : _1.AllowedTransactions.fromObject(args.transactionBlacklist);
    }
    copy() {
        return new KeyPage(this.asObject());
    }
    asObject() {
        return {
            type: "keyPage",
            url: this.url && this.url.toString(),
            creditBalance: this.creditBalance && this.creditBalance,
            acceptThreshold: this.acceptThreshold && this.acceptThreshold,
            rejectThreshold: this.rejectThreshold && this.rejectThreshold,
            responseThreshold: this.responseThreshold && this.responseThreshold,
            blockThreshold: this.blockThreshold && this.blockThreshold,
            version: this.version && this.version,
            keys: this.keys && this.keys?.map((v) => (v == undefined ? undefined : v.asObject())),
            transactionBlacklist: this.transactionBlacklist &&
                this.transactionBlacklist.map((v) => _1.TransactionType.getName(v)),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], KeyPage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], KeyPage.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], KeyPage.prototype, "creditBalance", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], KeyPage.prototype, "acceptThreshold", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], KeyPage.prototype, "rejectThreshold", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], KeyPage.prototype, "responseThreshold", void 0);
__decorate([
    encoding_1.encodeAs.field(7).uint
], KeyPage.prototype, "blockThreshold", void 0);
__decorate([
    encoding_1.encodeAs.field(8).uint
], KeyPage.prototype, "version", void 0);
__decorate([
    encoding_1.encodeAs.field(9).repeatable.reference
], KeyPage.prototype, "keys", void 0);
__decorate([
    encoding_1.encodeAs.field(10).enum
], KeyPage.prototype, "transactionBlacklist", void 0);
exports.KeyPage = KeyPage;
class KeySpec {
    constructor(args) {
        this.publicKeyHash =
            args.publicKeyHash == undefined
                ? undefined
                : args.publicKeyHash instanceof Uint8Array
                    ? args.publicKeyHash
                    : buffer_1.Buffer.from(args.publicKeyHash, "hex");
        this.lastUsedOn = args.lastUsedOn == undefined ? undefined : args.lastUsedOn;
        this.delegate = args.delegate == undefined ? undefined : url_1.AccumulateURL.parse(args.delegate);
    }
    copy() {
        return new KeySpec(this.asObject());
    }
    asObject() {
        return {
            publicKeyHash: this.publicKeyHash && this.publicKeyHash && buffer_1.Buffer.from(this.publicKeyHash).toString("hex"),
            lastUsedOn: this.lastUsedOn && this.lastUsedOn,
            delegate: this.delegate && this.delegate.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bytes
], KeySpec.prototype, "publicKeyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], KeySpec.prototype, "lastUsedOn", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], KeySpec.prototype, "delegate", void 0);
exports.KeySpec = KeySpec;
class KeySpecParams {
    constructor(args) {
        this.keyHash =
            args.keyHash == undefined
                ? undefined
                : args.keyHash instanceof Uint8Array
                    ? args.keyHash
                    : buffer_1.Buffer.from(args.keyHash, "hex");
        this.delegate = args.delegate == undefined ? undefined : url_1.AccumulateURL.parse(args.delegate);
    }
    copy() {
        return new KeySpecParams(this.asObject());
    }
    asObject() {
        return {
            keyHash: this.keyHash && this.keyHash && buffer_1.Buffer.from(this.keyHash).toString("hex"),
            delegate: this.delegate && this.delegate.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bytes
], KeySpecParams.prototype, "keyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], KeySpecParams.prototype, "delegate", void 0);
exports.KeySpecParams = KeySpecParams;
class LegacyED25519Signature {
    constructor(args) {
        this.type = _1.SignatureType.LegacyED25519;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
    }
    copy() {
        return new LegacyED25519Signature(this.asObject());
    }
    asObject() {
        return {
            type: "legacyED25519",
            timestamp: this.timestamp && this.timestamp,
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], LegacyED25519Signature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], LegacyED25519Signature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], LegacyED25519Signature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bytes
], LegacyED25519Signature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(5).url
], LegacyED25519Signature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], LegacyED25519Signature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], LegacyED25519Signature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], LegacyED25519Signature.prototype, "transactionHash", void 0);
exports.LegacyED25519Signature = LegacyED25519Signature;
class LiteDataAccount {
    constructor(args) {
        this.type = _1.AccountType.LiteDataAccount;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
    }
    copy() {
        return new LiteDataAccount(this.asObject());
    }
    asObject() {
        return {
            type: "liteDataAccount",
            url: this.url && this.url.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], LiteDataAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], LiteDataAccount.prototype, "url", void 0);
exports.LiteDataAccount = LiteDataAccount;
class LiteIdentity {
    constructor(args) {
        this.type = _1.AccountType.LiteIdentity;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.creditBalance = args.creditBalance == undefined ? undefined : args.creditBalance;
        this.lastUsedOn = args.lastUsedOn == undefined ? undefined : args.lastUsedOn;
    }
    copy() {
        return new LiteIdentity(this.asObject());
    }
    asObject() {
        return {
            type: "liteIdentity",
            url: this.url && this.url.toString(),
            creditBalance: this.creditBalance && this.creditBalance,
            lastUsedOn: this.lastUsedOn && this.lastUsedOn,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], LiteIdentity.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], LiteIdentity.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], LiteIdentity.prototype, "creditBalance", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], LiteIdentity.prototype, "lastUsedOn", void 0);
exports.LiteIdentity = LiteIdentity;
class LiteTokenAccount {
    constructor(args) {
        this.type = _1.AccountType.LiteTokenAccount;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.tokenUrl = args.tokenUrl == undefined ? undefined : url_1.AccumulateURL.parse(args.tokenUrl);
        this.balance =
            args.balance == undefined
                ? undefined
                : typeof args.balance === "bigint"
                    ? args.balance
                    : BigInt(args.balance);
        this.lockHeight = args.lockHeight == undefined ? undefined : args.lockHeight;
    }
    copy() {
        return new LiteTokenAccount(this.asObject());
    }
    asObject() {
        return {
            type: "liteTokenAccount",
            url: this.url && this.url.toString(),
            tokenUrl: this.tokenUrl && this.tokenUrl.toString(),
            balance: this.balance && this.balance.toString(),
            lockHeight: this.lockHeight && this.lockHeight,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], LiteTokenAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], LiteTokenAccount.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], LiteTokenAccount.prototype, "tokenUrl", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bigInt
], LiteTokenAccount.prototype, "balance", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], LiteTokenAccount.prototype, "lockHeight", void 0);
exports.LiteTokenAccount = LiteTokenAccount;
class LockAccount {
    constructor(args) {
        this.type = _1.TransactionType.LockAccount;
        this.height = args.height == undefined ? undefined : args.height;
    }
    copy() {
        return new LockAccount(this.asObject());
    }
    asObject() {
        return {
            type: "lockAccount",
            height: this.height && this.height,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], LockAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], LockAccount.prototype, "height", void 0);
exports.LockAccount = LockAccount;
class NetworkAccountUpdate {
    constructor(args) {
        this.name = args.name == undefined ? undefined : args.name;
        this.body = args.body == undefined ? undefined : _1.TransactionBody.fromObject(args.body);
    }
    copy() {
        return new NetworkAccountUpdate(this.asObject());
    }
    asObject() {
        return {
            name: this.name && this.name,
            body: this.body && this.body.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], NetworkAccountUpdate.prototype, "name", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], NetworkAccountUpdate.prototype, "body", void 0);
exports.NetworkAccountUpdate = NetworkAccountUpdate;
class NetworkDefinition {
    constructor(args) {
        this.networkName = args.networkName == undefined ? undefined : args.networkName;
        this.version = args.version == undefined ? undefined : args.version;
        this.partitions =
            args.partitions == undefined
                ? undefined
                : args.partitions.map((v) => v == undefined ? undefined : v instanceof PartitionInfo ? v : new PartitionInfo(v));
        this.validators =
            args.validators == undefined
                ? undefined
                : args.validators.map((v) => v == undefined ? undefined : v instanceof ValidatorInfo ? v : new ValidatorInfo(v));
    }
    copy() {
        return new NetworkDefinition(this.asObject());
    }
    asObject() {
        return {
            networkName: this.networkName && this.networkName,
            version: this.version && this.version,
            partitions: this.partitions && this.partitions?.map((v) => (v == undefined ? undefined : v.asObject())),
            validators: this.validators && this.validators?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], NetworkDefinition.prototype, "networkName", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], NetworkDefinition.prototype, "version", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.reference
], NetworkDefinition.prototype, "partitions", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], NetworkDefinition.prototype, "validators", void 0);
exports.NetworkDefinition = NetworkDefinition;
class NetworkGlobals {
    constructor(args) {
        this.operatorAcceptThreshold =
            args.operatorAcceptThreshold == undefined
                ? undefined
                : args.operatorAcceptThreshold instanceof Rational
                    ? args.operatorAcceptThreshold
                    : new Rational(args.operatorAcceptThreshold);
        this.validatorAcceptThreshold =
            args.validatorAcceptThreshold == undefined
                ? undefined
                : args.validatorAcceptThreshold instanceof Rational
                    ? args.validatorAcceptThreshold
                    : new Rational(args.validatorAcceptThreshold);
        this.majorBlockSchedule =
            args.majorBlockSchedule == undefined ? undefined : args.majorBlockSchedule;
        this.anchorEmptyBlocks =
            args.anchorEmptyBlocks == undefined ? undefined : args.anchorEmptyBlocks;
        this.feeSchedule =
            args.feeSchedule == undefined
                ? undefined
                : args.feeSchedule instanceof FeeSchedule
                    ? args.feeSchedule
                    : new FeeSchedule(args.feeSchedule);
        this.limits =
            args.limits == undefined
                ? undefined
                : args.limits instanceof NetworkLimits
                    ? args.limits
                    : new NetworkLimits(args.limits);
    }
    copy() {
        return new NetworkGlobals(this.asObject());
    }
    asObject() {
        return {
            operatorAcceptThreshold: this.operatorAcceptThreshold && this.operatorAcceptThreshold.asObject(),
            validatorAcceptThreshold: this.validatorAcceptThreshold && this.validatorAcceptThreshold.asObject(),
            majorBlockSchedule: this.majorBlockSchedule && this.majorBlockSchedule,
            anchorEmptyBlocks: this.anchorEmptyBlocks && this.anchorEmptyBlocks,
            feeSchedule: this.feeSchedule && this.feeSchedule.asObject(),
            limits: this.limits && this.limits.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], NetworkGlobals.prototype, "operatorAcceptThreshold", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], NetworkGlobals.prototype, "validatorAcceptThreshold", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], NetworkGlobals.prototype, "majorBlockSchedule", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bool
], NetworkGlobals.prototype, "anchorEmptyBlocks", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], NetworkGlobals.prototype, "feeSchedule", void 0);
__decorate([
    encoding_1.encodeAs.field(6).reference
], NetworkGlobals.prototype, "limits", void 0);
exports.NetworkGlobals = NetworkGlobals;
class NetworkLimits {
    constructor(args) {
        this.dataEntryParts = args.dataEntryParts == undefined ? undefined : args.dataEntryParts;
        this.accountAuthorities =
            args.accountAuthorities == undefined ? undefined : args.accountAuthorities;
        this.bookPages = args.bookPages == undefined ? undefined : args.bookPages;
        this.pageEntries = args.pageEntries == undefined ? undefined : args.pageEntries;
        this.identityAccounts = args.identityAccounts == undefined ? undefined : args.identityAccounts;
        this.pendingMajorBlocks =
            args.pendingMajorBlocks == undefined ? undefined : args.pendingMajorBlocks;
        this.eventsPerBlock = args.eventsPerBlock == undefined ? undefined : args.eventsPerBlock;
    }
    copy() {
        return new NetworkLimits(this.asObject());
    }
    asObject() {
        return {
            dataEntryParts: this.dataEntryParts && this.dataEntryParts,
            accountAuthorities: this.accountAuthorities && this.accountAuthorities,
            bookPages: this.bookPages && this.bookPages,
            pageEntries: this.pageEntries && this.pageEntries,
            identityAccounts: this.identityAccounts && this.identityAccounts,
            pendingMajorBlocks: this.pendingMajorBlocks && this.pendingMajorBlocks,
            eventsPerBlock: this.eventsPerBlock && this.eventsPerBlock,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], NetworkLimits.prototype, "dataEntryParts", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], NetworkLimits.prototype, "accountAuthorities", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], NetworkLimits.prototype, "bookPages", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], NetworkLimits.prototype, "pageEntries", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], NetworkLimits.prototype, "identityAccounts", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], NetworkLimits.prototype, "pendingMajorBlocks", void 0);
__decorate([
    encoding_1.encodeAs.field(7).uint
], NetworkLimits.prototype, "eventsPerBlock", void 0);
exports.NetworkLimits = NetworkLimits;
class NetworkMaintenance {
    constructor(args) {
        this.type = _1.TransactionType.NetworkMaintenance;
        this.operations =
            args.operations == undefined
                ? undefined
                : args.operations.map((v) => v == undefined ? undefined : _1.NetworkMaintenanceOperation.fromObject(v));
    }
    copy() {
        return new NetworkMaintenance(this.asObject());
    }
    asObject() {
        return {
            type: "networkMaintenance",
            operations: this.operations && this.operations?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], NetworkMaintenance.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.union
], NetworkMaintenance.prototype, "operations", void 0);
exports.NetworkMaintenance = NetworkMaintenance;
class PartitionAnchor {
    constructor(args) {
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.majorBlockIndex = args.majorBlockIndex == undefined ? undefined : args.majorBlockIndex;
        this.minorBlockIndex = args.minorBlockIndex == undefined ? undefined : args.minorBlockIndex;
        this.rootChainIndex = args.rootChainIndex == undefined ? undefined : args.rootChainIndex;
        this.rootChainAnchor =
            args.rootChainAnchor == undefined
                ? undefined
                : args.rootChainAnchor instanceof Uint8Array
                    ? args.rootChainAnchor
                    : buffer_1.Buffer.from(args.rootChainAnchor, "hex");
        this.stateTreeAnchor =
            args.stateTreeAnchor == undefined
                ? undefined
                : args.stateTreeAnchor instanceof Uint8Array
                    ? args.stateTreeAnchor
                    : buffer_1.Buffer.from(args.stateTreeAnchor, "hex");
    }
    copy() {
        return new PartitionAnchor(this.asObject());
    }
    asObject() {
        return {
            source: this.source && this.source.toString(),
            majorBlockIndex: this.majorBlockIndex && this.majorBlockIndex,
            minorBlockIndex: this.minorBlockIndex && this.minorBlockIndex,
            rootChainIndex: this.rootChainIndex && this.rootChainIndex,
            rootChainAnchor: this.rootChainAnchor &&
                this.rootChainAnchor &&
                buffer_1.Buffer.from(this.rootChainAnchor).toString("hex"),
            stateTreeAnchor: this.stateTreeAnchor &&
                this.stateTreeAnchor &&
                buffer_1.Buffer.from(this.stateTreeAnchor).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], PartitionAnchor.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], PartitionAnchor.prototype, "majorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], PartitionAnchor.prototype, "minorBlockIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], PartitionAnchor.prototype, "rootChainIndex", void 0);
__decorate([
    encoding_1.encodeAs.field(5).hash
], PartitionAnchor.prototype, "rootChainAnchor", void 0);
__decorate([
    encoding_1.encodeAs.field(6).hash
], PartitionAnchor.prototype, "stateTreeAnchor", void 0);
exports.PartitionAnchor = PartitionAnchor;
class PartitionAnchorReceipt {
    constructor(args) {
        this.anchor =
            args.anchor == undefined
                ? undefined
                : args.anchor instanceof PartitionAnchor
                    ? args.anchor
                    : new PartitionAnchor(args.anchor);
        this.rootChainReceipt =
            args.rootChainReceipt == undefined
                ? undefined
                : args.rootChainReceipt instanceof merkle.Receipt
                    ? args.rootChainReceipt
                    : new merkle.Receipt(args.rootChainReceipt);
    }
    copy() {
        return new PartitionAnchorReceipt(this.asObject());
    }
    asObject() {
        return {
            anchor: this.anchor && this.anchor.asObject(),
            rootChainReceipt: this.rootChainReceipt && this.rootChainReceipt.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], PartitionAnchorReceipt.prototype, "anchor", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], PartitionAnchorReceipt.prototype, "rootChainReceipt", void 0);
exports.PartitionAnchorReceipt = PartitionAnchorReceipt;
class PartitionExecutorVersion {
    constructor(args) {
        this.partition = args.partition == undefined ? undefined : args.partition;
        this.version = args.version == undefined ? undefined : _1.ExecutorVersion.fromObject(args.version);
    }
    copy() {
        return new PartitionExecutorVersion(this.asObject());
    }
    asObject() {
        return {
            partition: this.partition && this.partition,
            version: this.version && _1.ExecutorVersion.getName(this.version),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], PartitionExecutorVersion.prototype, "partition", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], PartitionExecutorVersion.prototype, "version", void 0);
exports.PartitionExecutorVersion = PartitionExecutorVersion;
class PartitionInfo {
    constructor(args) {
        this.id = args.id == undefined ? undefined : args.id;
        this.type = args.type == undefined ? undefined : _1.PartitionType.fromObject(args.type);
    }
    copy() {
        return new PartitionInfo(this.asObject());
    }
    asObject() {
        return {
            id: this.id && this.id,
            type: this.type && _1.PartitionType.getName(this.type),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], PartitionInfo.prototype, "id", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], PartitionInfo.prototype, "type", void 0);
exports.PartitionInfo = PartitionInfo;
class PartitionSignature {
    constructor(args) {
        this.type = _1.SignatureType.Partition;
        this.sourceNetwork =
            args.sourceNetwork == undefined ? undefined : url_1.AccumulateURL.parse(args.sourceNetwork);
        this.destinationNetwork =
            args.destinationNetwork == undefined ? undefined : url_1.AccumulateURL.parse(args.destinationNetwork);
        this.sequenceNumber = args.sequenceNumber == undefined ? undefined : args.sequenceNumber;
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
    }
    copy() {
        return new PartitionSignature(this.asObject());
    }
    asObject() {
        return {
            type: "partition",
            sourceNetwork: this.sourceNetwork && this.sourceNetwork.toString(),
            destinationNetwork: this.destinationNetwork && this.destinationNetwork.toString(),
            sequenceNumber: this.sequenceNumber && this.sequenceNumber,
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], PartitionSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], PartitionSignature.prototype, "sourceNetwork", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], PartitionSignature.prototype, "destinationNetwork", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], PartitionSignature.prototype, "sequenceNumber", void 0);
__decorate([
    encoding_1.encodeAs.field(5).hash
], PartitionSignature.prototype, "transactionHash", void 0);
exports.PartitionSignature = PartitionSignature;
class PartitionSyntheticLedger {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.produced = args.produced == undefined ? undefined : args.produced;
        this.received = args.received == undefined ? undefined : args.received;
        this.delivered = args.delivered == undefined ? undefined : args.delivered;
        this.pending =
            args.pending == undefined
                ? undefined
                : args.pending.map((v) => (v == undefined ? undefined : txid_1.AccumulateTxID.parse(v)));
    }
    copy() {
        return new PartitionSyntheticLedger(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            produced: this.produced && this.produced,
            received: this.received && this.received,
            delivered: this.delivered && this.delivered,
            pending: this.pending && this.pending?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], PartitionSyntheticLedger.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], PartitionSyntheticLedger.prototype, "produced", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], PartitionSyntheticLedger.prototype, "received", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], PartitionSyntheticLedger.prototype, "delivered", void 0);
__decorate([
    encoding_1.encodeAs.field(5).repeatable.txid
], PartitionSyntheticLedger.prototype, "pending", void 0);
exports.PartitionSyntheticLedger = PartitionSyntheticLedger;
class PendingTransactionGCOperation {
    constructor(args) {
        this.type = _1.NetworkMaintenanceOperationType.PendingTransactionGC;
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
    }
    copy() {
        return new PendingTransactionGCOperation(this.asObject());
    }
    asObject() {
        return {
            type: "pendingTransactionGC",
            account: this.account && this.account.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.NetworkMaintenanceOperationType)
], PendingTransactionGCOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], PendingTransactionGCOperation.prototype, "account", void 0);
exports.PendingTransactionGCOperation = PendingTransactionGCOperation;
class RCD1Signature {
    constructor(args) {
        this.type = _1.SignatureType.RCD1;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new RCD1Signature(this.asObject());
    }
    asObject() {
        return {
            type: "rcd1",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], RCD1Signature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], RCD1Signature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], RCD1Signature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], RCD1Signature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], RCD1Signature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], RCD1Signature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], RCD1Signature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], RCD1Signature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], RCD1Signature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], RCD1Signature.prototype, "data", void 0);
exports.RCD1Signature = RCD1Signature;
class Rational {
    constructor(args) {
        this.numerator = args.numerator == undefined ? undefined : args.numerator;
        this.denominator = args.denominator == undefined ? undefined : args.denominator;
    }
    copy() {
        return new Rational(this.asObject());
    }
    asObject() {
        return {
            numerator: this.numerator && this.numerator,
            denominator: this.denominator && this.denominator,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], Rational.prototype, "numerator", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], Rational.prototype, "denominator", void 0);
exports.Rational = Rational;
class ReceiptSignature {
    constructor(args) {
        this.type = _1.SignatureType.Receipt;
        this.sourceNetwork =
            args.sourceNetwork == undefined ? undefined : url_1.AccumulateURL.parse(args.sourceNetwork);
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof merkle.Receipt
                    ? args.proof
                    : new merkle.Receipt(args.proof);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
    }
    copy() {
        return new ReceiptSignature(this.asObject());
    }
    asObject() {
        return {
            type: "receipt",
            sourceNetwork: this.sourceNetwork && this.sourceNetwork.toString(),
            proof: this.proof && this.proof.asObject(),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], ReceiptSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], ReceiptSignature.prototype, "sourceNetwork", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], ReceiptSignature.prototype, "proof", void 0);
__decorate([
    encoding_1.encodeAs.field(4).hash
], ReceiptSignature.prototype, "transactionHash", void 0);
exports.ReceiptSignature = ReceiptSignature;
class RemoteSignature {
    constructor(args) {
        this.type = _1.SignatureType.Remote;
        this.destination = args.destination == undefined ? undefined : url_1.AccumulateURL.parse(args.destination);
        this.signature = args.signature == undefined ? undefined : _1.Signature.fromObject(args.signature);
        this.cause =
            args.cause == undefined
                ? undefined
                : args.cause.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new RemoteSignature(this.asObject());
    }
    asObject() {
        return {
            type: "remote",
            destination: this.destination && this.destination.toString(),
            signature: this.signature && this.signature.asObject(),
            cause: this.cause &&
                this.cause?.map((v) => (v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex"))),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], RemoteSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], RemoteSignature.prototype, "destination", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], RemoteSignature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.hash
], RemoteSignature.prototype, "cause", void 0);
exports.RemoteSignature = RemoteSignature;
class RemoteTransaction {
    constructor(args) {
        this.type = _1.TransactionType.Remote;
        this.hash =
            args.hash == undefined
                ? undefined
                : args.hash instanceof Uint8Array
                    ? args.hash
                    : buffer_1.Buffer.from(args.hash, "hex");
    }
    copy() {
        return new RemoteTransaction(this.asObject());
    }
    asObject() {
        return {
            type: "remote",
            hash: this.hash && this.hash && buffer_1.Buffer.from(this.hash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], RemoteTransaction.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], RemoteTransaction.prototype, "hash", void 0);
exports.RemoteTransaction = RemoteTransaction;
class RemoveAccountAuthorityOperation {
    constructor(args) {
        this.type = _1.AccountAuthOperationType.RemoveAuthority;
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
    }
    copy() {
        return new RemoveAccountAuthorityOperation(this.asObject());
    }
    asObject() {
        return {
            type: "removeAuthority",
            authority: this.authority && this.authority.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountAuthOperationType)
], RemoveAccountAuthorityOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], RemoveAccountAuthorityOperation.prototype, "authority", void 0);
exports.RemoveAccountAuthorityOperation = RemoveAccountAuthorityOperation;
class RemoveKeyOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.Remove;
        this.entry =
            args.entry == undefined
                ? undefined
                : args.entry instanceof KeySpecParams
                    ? args.entry
                    : new KeySpecParams(args.entry);
    }
    copy() {
        return new RemoveKeyOperation(this.asObject());
    }
    asObject() {
        return {
            type: "remove",
            entry: this.entry && this.entry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], RemoveKeyOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], RemoveKeyOperation.prototype, "entry", void 0);
exports.RemoveKeyOperation = RemoveKeyOperation;
class Route {
    constructor(args) {
        this.length = args.length == undefined ? undefined : args.length;
        this.value = args.value == undefined ? undefined : args.value;
        this.partition = args.partition == undefined ? undefined : args.partition;
    }
    copy() {
        return new Route(this.asObject());
    }
    asObject() {
        return {
            length: this.length && this.length,
            value: this.value && this.value,
            partition: this.partition && this.partition,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).uint
], Route.prototype, "length", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], Route.prototype, "value", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], Route.prototype, "partition", void 0);
exports.Route = Route;
class RouteOverride {
    constructor(args) {
        this.account = args.account == undefined ? undefined : url_1.AccumulateURL.parse(args.account);
        this.partition = args.partition == undefined ? undefined : args.partition;
    }
    copy() {
        return new RouteOverride(this.asObject());
    }
    asObject() {
        return {
            account: this.account && this.account.toString(),
            partition: this.partition && this.partition,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], RouteOverride.prototype, "account", void 0);
__decorate([
    encoding_1.encodeAs.field(2).string
], RouteOverride.prototype, "partition", void 0);
exports.RouteOverride = RouteOverride;
class RoutingTable {
    constructor(args) {
        this.overrides =
            args.overrides == undefined
                ? undefined
                : args.overrides.map((v) => v == undefined ? undefined : v instanceof RouteOverride ? v : new RouteOverride(v));
        this.routes =
            args.routes == undefined
                ? undefined
                : args.routes.map((v) => v == undefined ? undefined : v instanceof Route ? v : new Route(v));
    }
    copy() {
        return new RoutingTable(this.asObject());
    }
    asObject() {
        return {
            overrides: this.overrides && this.overrides?.map((v) => (v == undefined ? undefined : v.asObject())),
            routes: this.routes && this.routes?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).repeatable.reference
], RoutingTable.prototype, "overrides", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.reference
], RoutingTable.prototype, "routes", void 0);
exports.RoutingTable = RoutingTable;
class RsaSha256Signature {
    constructor(args) {
        this.type = _1.SignatureType.RsaSha256;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
    }
    copy() {
        return new RsaSha256Signature(this.asObject());
    }
    asObject() {
        return {
            type: "rsaSha256",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], RsaSha256Signature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], RsaSha256Signature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], RsaSha256Signature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], RsaSha256Signature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], RsaSha256Signature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], RsaSha256Signature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], RsaSha256Signature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], RsaSha256Signature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], RsaSha256Signature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], RsaSha256Signature.prototype, "data", void 0);
exports.RsaSha256Signature = RsaSha256Signature;
class SendTokens {
    constructor(args) {
        this.type = _1.TransactionType.SendTokens;
        this.hash =
            args.hash == undefined
                ? undefined
                : args.hash instanceof Uint8Array
                    ? args.hash
                    : buffer_1.Buffer.from(args.hash, "hex");
        this.meta = args.meta == undefined ? undefined : args.meta;
        this.to =
            args.to == undefined
                ? undefined
                : args.to.map((v) => v == undefined ? undefined : v instanceof TokenRecipient ? v : new TokenRecipient(v));
    }
    copy() {
        return new SendTokens(this.asObject());
    }
    asObject() {
        return {
            type: "sendTokens",
            hash: this.hash && this.hash && buffer_1.Buffer.from(this.hash).toString("hex"),
            meta: this.meta && this.meta,
            to: this.to && this.to?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SendTokens.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], SendTokens.prototype, "hash", void 0);
__decorate([
    encoding_1.encodeAs.field(3).rawJson
], SendTokens.prototype, "meta", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], SendTokens.prototype, "to", void 0);
exports.SendTokens = SendTokens;
class SetRejectThresholdKeyPageOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.SetRejectThreshold;
        this.threshold = args.threshold == undefined ? undefined : args.threshold;
    }
    copy() {
        return new SetRejectThresholdKeyPageOperation(this.asObject());
    }
    asObject() {
        return {
            type: "setRejectThreshold",
            threshold: this.threshold && this.threshold,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], SetRejectThresholdKeyPageOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], SetRejectThresholdKeyPageOperation.prototype, "threshold", void 0);
exports.SetRejectThresholdKeyPageOperation = SetRejectThresholdKeyPageOperation;
class SetResponseThresholdKeyPageOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.SetResponseThreshold;
        this.threshold = args.threshold == undefined ? undefined : args.threshold;
    }
    copy() {
        return new SetResponseThresholdKeyPageOperation(this.asObject());
    }
    asObject() {
        return {
            type: "setResponseThreshold",
            threshold: this.threshold && this.threshold,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], SetResponseThresholdKeyPageOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], SetResponseThresholdKeyPageOperation.prototype, "threshold", void 0);
exports.SetResponseThresholdKeyPageOperation = SetResponseThresholdKeyPageOperation;
class SetThresholdKeyPageOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.SetThreshold;
        this.threshold = args.threshold == undefined ? undefined : args.threshold;
    }
    copy() {
        return new SetThresholdKeyPageOperation(this.asObject());
    }
    asObject() {
        return {
            type: "setThreshold",
            threshold: this.threshold && this.threshold,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], SetThresholdKeyPageOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).uint
], SetThresholdKeyPageOperation.prototype, "threshold", void 0);
exports.SetThresholdKeyPageOperation = SetThresholdKeyPageOperation;
class SignatureSet {
    constructor(args) {
        this.type = _1.SignatureType.Set;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures.map((v) => (v == undefined ? undefined : _1.Signature.fromObject(v)));
        this.authority = args.authority == undefined ? undefined : url_1.AccumulateURL.parse(args.authority);
    }
    copy() {
        return new SignatureSet(this.asObject());
    }
    asObject() {
        return {
            type: "set",
            vote: this.vote && _1.VoteType.getName(this.vote),
            signer: this.signer && this.signer.toString(),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            signatures: this.signatures && this.signatures?.map((v) => (v == undefined ? undefined : v.asObject())),
            authority: this.authority && this.authority.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], SignatureSet.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], SignatureSet.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], SignatureSet.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(4).hash
], SignatureSet.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(5).repeatable.union
], SignatureSet.prototype, "signatures", void 0);
__decorate([
    encoding_1.encodeAs.field(6).url
], SignatureSet.prototype, "authority", void 0);
exports.SignatureSet = SignatureSet;
class SyntheticBurnTokens {
    constructor(args) {
        this.type = _1.TransactionType.SyntheticBurnTokens;
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.feeRefund = args.feeRefund == undefined ? undefined : args.feeRefund;
        this.index = args.index == undefined ? undefined : args.index;
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
        this.isRefund = args.isRefund == undefined ? undefined : args.isRefund;
    }
    copy() {
        return new SyntheticBurnTokens(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticBurnTokens",
            cause: this.cause && this.cause.toString(),
            source: this.source && this.source.toString(),
            initiator: this.initiator && this.initiator.toString(),
            feeRefund: this.feeRefund && this.feeRefund,
            index: this.index && this.index,
            amount: this.amount && this.amount.toString(),
            isRefund: this.isRefund && this.isRefund,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SyntheticBurnTokens.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).txid
], SyntheticBurnTokens.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 0).url
], SyntheticBurnTokens.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).url
], SyntheticBurnTokens.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], SyntheticBurnTokens.prototype, "feeRefund", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).uint
], SyntheticBurnTokens.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bigInt
], SyntheticBurnTokens.prototype, "amount", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bool
], SyntheticBurnTokens.prototype, "isRefund", void 0);
exports.SyntheticBurnTokens = SyntheticBurnTokens;
class SyntheticCreateIdentity {
    constructor(args) {
        this.type = _1.TransactionType.SyntheticCreateIdentity;
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.feeRefund = args.feeRefund == undefined ? undefined : args.feeRefund;
        this.index = args.index == undefined ? undefined : args.index;
        this.accounts =
            args.accounts == undefined
                ? undefined
                : args.accounts.map((v) => (v == undefined ? undefined : _1.Account.fromObject(v)));
    }
    copy() {
        return new SyntheticCreateIdentity(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticCreateIdentity",
            cause: this.cause && this.cause.toString(),
            source: this.source && this.source.toString(),
            initiator: this.initiator && this.initiator.toString(),
            feeRefund: this.feeRefund && this.feeRefund,
            index: this.index && this.index,
            accounts: this.accounts && this.accounts?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SyntheticCreateIdentity.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).txid
], SyntheticCreateIdentity.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 0).url
], SyntheticCreateIdentity.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).url
], SyntheticCreateIdentity.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], SyntheticCreateIdentity.prototype, "feeRefund", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).uint
], SyntheticCreateIdentity.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.union
], SyntheticCreateIdentity.prototype, "accounts", void 0);
exports.SyntheticCreateIdentity = SyntheticCreateIdentity;
class SyntheticDepositCredits {
    constructor(args) {
        this.type = _1.TransactionType.SyntheticDepositCredits;
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.feeRefund = args.feeRefund == undefined ? undefined : args.feeRefund;
        this.index = args.index == undefined ? undefined : args.index;
        this.amount = args.amount == undefined ? undefined : args.amount;
        this.acmeRefundAmount =
            args.acmeRefundAmount == undefined
                ? undefined
                : typeof args.acmeRefundAmount === "bigint"
                    ? args.acmeRefundAmount
                    : BigInt(args.acmeRefundAmount);
        this.isRefund = args.isRefund == undefined ? undefined : args.isRefund;
    }
    copy() {
        return new SyntheticDepositCredits(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticDepositCredits",
            cause: this.cause && this.cause.toString(),
            source: this.source && this.source.toString(),
            initiator: this.initiator && this.initiator.toString(),
            feeRefund: this.feeRefund && this.feeRefund,
            index: this.index && this.index,
            amount: this.amount && this.amount,
            acmeRefundAmount: this.acmeRefundAmount && this.acmeRefundAmount.toString(),
            isRefund: this.isRefund && this.isRefund,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SyntheticDepositCredits.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).txid
], SyntheticDepositCredits.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 0).url
], SyntheticDepositCredits.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).url
], SyntheticDepositCredits.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], SyntheticDepositCredits.prototype, "feeRefund", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).uint
], SyntheticDepositCredits.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], SyntheticDepositCredits.prototype, "amount", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bigInt
], SyntheticDepositCredits.prototype, "acmeRefundAmount", void 0);
__decorate([
    encoding_1.encodeAs.field(5).bool
], SyntheticDepositCredits.prototype, "isRefund", void 0);
exports.SyntheticDepositCredits = SyntheticDepositCredits;
class SyntheticDepositTokens {
    constructor(args) {
        this.type = _1.TransactionType.SyntheticDepositTokens;
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.feeRefund = args.feeRefund == undefined ? undefined : args.feeRefund;
        this.index = args.index == undefined ? undefined : args.index;
        this.token = args.token == undefined ? undefined : url_1.AccumulateURL.parse(args.token);
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
        this.isIssuer = args.isIssuer == undefined ? undefined : args.isIssuer;
        this.isRefund = args.isRefund == undefined ? undefined : args.isRefund;
    }
    copy() {
        return new SyntheticDepositTokens(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticDepositTokens",
            cause: this.cause && this.cause.toString(),
            source: this.source && this.source.toString(),
            initiator: this.initiator && this.initiator.toString(),
            feeRefund: this.feeRefund && this.feeRefund,
            index: this.index && this.index,
            token: this.token && this.token.toString(),
            amount: this.amount && this.amount.toString(),
            isIssuer: this.isIssuer && this.isIssuer,
            isRefund: this.isRefund && this.isRefund,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SyntheticDepositTokens.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).txid
], SyntheticDepositTokens.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 0).url
], SyntheticDepositTokens.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).url
], SyntheticDepositTokens.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], SyntheticDepositTokens.prototype, "feeRefund", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).uint
], SyntheticDepositTokens.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], SyntheticDepositTokens.prototype, "token", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bigInt
], SyntheticDepositTokens.prototype, "amount", void 0);
__decorate([
    encoding_1.encodeAs.field(5).bool
], SyntheticDepositTokens.prototype, "isIssuer", void 0);
__decorate([
    encoding_1.encodeAs.field(6).bool
], SyntheticDepositTokens.prototype, "isRefund", void 0);
exports.SyntheticDepositTokens = SyntheticDepositTokens;
class SyntheticForwardTransaction {
    constructor(args) {
        this.type = _1.TransactionType.SyntheticForwardTransaction;
        this.signatures =
            args.signatures == undefined
                ? undefined
                : args.signatures.map((v) => v == undefined ? undefined : v instanceof RemoteSignature ? v : new RemoteSignature(v));
        this.transaction =
            args.transaction == undefined
                ? undefined
                : args.transaction instanceof Transaction
                    ? args.transaction
                    : new Transaction(args.transaction);
    }
    copy() {
        return new SyntheticForwardTransaction(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticForwardTransaction",
            signatures: this.signatures && this.signatures?.map((v) => (v == undefined ? undefined : v.asObject())),
            transaction: this.transaction && this.transaction.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SyntheticForwardTransaction.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.reference
], SyntheticForwardTransaction.prototype, "signatures", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], SyntheticForwardTransaction.prototype, "transaction", void 0);
exports.SyntheticForwardTransaction = SyntheticForwardTransaction;
class SyntheticLedger {
    constructor(args) {
        this.type = _1.AccountType.SyntheticLedger;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.sequence =
            args.sequence == undefined
                ? undefined
                : args.sequence.map((v) => v == undefined
                    ? undefined
                    : v instanceof PartitionSyntheticLedger
                        ? v
                        : new PartitionSyntheticLedger(v));
    }
    copy() {
        return new SyntheticLedger(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticLedger",
            url: this.url && this.url.toString(),
            sequence: this.sequence && this.sequence?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], SyntheticLedger.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], SyntheticLedger.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.reference
], SyntheticLedger.prototype, "sequence", void 0);
exports.SyntheticLedger = SyntheticLedger;
class SyntheticOrigin {
    constructor(args) {
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.feeRefund = args.feeRefund == undefined ? undefined : args.feeRefund;
        this.index = args.index == undefined ? undefined : args.index;
    }
    copy() {
        return new SyntheticOrigin(this.asObject());
    }
    asObject() {
        return {
            cause: this.cause && this.cause.toString(),
            initiator: this.initiator && this.initiator.toString(),
            feeRefund: this.feeRefund && this.feeRefund,
            index: this.index && this.index,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).txid
], SyntheticOrigin.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], SyntheticOrigin.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(4).uint
], SyntheticOrigin.prototype, "feeRefund", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], SyntheticOrigin.prototype, "index", void 0);
exports.SyntheticOrigin = SyntheticOrigin;
class SyntheticWriteData {
    constructor(args) {
        this.type = _1.TransactionType.SyntheticWriteData;
        this.cause = args.cause == undefined ? undefined : txid_1.AccumulateTxID.parse(args.cause);
        this.source = args.source == undefined ? undefined : url_1.AccumulateURL.parse(args.source);
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.feeRefund = args.feeRefund == undefined ? undefined : args.feeRefund;
        this.index = args.index == undefined ? undefined : args.index;
        this.entry = args.entry == undefined ? undefined : _1.DataEntry.fromObject(args.entry);
    }
    copy() {
        return new SyntheticWriteData(this.asObject());
    }
    asObject() {
        return {
            type: "syntheticWriteData",
            cause: this.cause && this.cause.toString(),
            source: this.source && this.source.toString(),
            initiator: this.initiator && this.initiator.toString(),
            feeRefund: this.feeRefund && this.feeRefund,
            index: this.index && this.index,
            entry: this.entry && this.entry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SyntheticWriteData.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 1).txid
], SyntheticWriteData.prototype, "cause", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 0).url
], SyntheticWriteData.prototype, "source", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 3).url
], SyntheticWriteData.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 4).uint
], SyntheticWriteData.prototype, "feeRefund", void 0);
__decorate([
    encoding_1.encodeAs.field(2, 5).uint
], SyntheticWriteData.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], SyntheticWriteData.prototype, "entry", void 0);
exports.SyntheticWriteData = SyntheticWriteData;
class SystemGenesis {
    constructor(_) {
        this.type = _1.TransactionType.SystemGenesis;
    }
    copy() {
        return new SystemGenesis(this.asObject());
    }
    asObject() {
        return {
            type: "systemGenesis",
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SystemGenesis.prototype, "type", void 0);
exports.SystemGenesis = SystemGenesis;
class SystemLedger {
    constructor(args) {
        this.type = _1.AccountType.SystemLedger;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.index = args.index == undefined ? undefined : args.index;
        this.timestamp =
            args.timestamp == undefined
                ? undefined
                : args.timestamp instanceof Date
                    ? args.timestamp
                    : new Date(args.timestamp);
        this.acmeBurnt =
            args.acmeBurnt == undefined
                ? undefined
                : typeof args.acmeBurnt === "bigint"
                    ? args.acmeBurnt
                    : BigInt(args.acmeBurnt);
        this.pendingUpdates =
            args.pendingUpdates == undefined
                ? undefined
                : args.pendingUpdates.map((v) => v == undefined
                    ? undefined
                    : v instanceof NetworkAccountUpdate
                        ? v
                        : new NetworkAccountUpdate(v));
        this.anchor = args.anchor == undefined ? undefined : _1.AnchorBody.fromObject(args.anchor);
        this.executorVersion =
            args.executorVersion == undefined
                ? undefined
                : _1.ExecutorVersion.fromObject(args.executorVersion);
        this.bvnExecutorVersions =
            args.bvnExecutorVersions == undefined
                ? undefined
                : args.bvnExecutorVersions.map((v) => v == undefined
                    ? undefined
                    : v instanceof PartitionExecutorVersion
                        ? v
                        : new PartitionExecutorVersion(v));
    }
    copy() {
        return new SystemLedger(this.asObject());
    }
    asObject() {
        return {
            type: "systemLedger",
            url: this.url && this.url.toString(),
            index: this.index && this.index,
            timestamp: this.timestamp && this.timestamp,
            acmeBurnt: this.acmeBurnt && this.acmeBurnt.toString(),
            pendingUpdates: this.pendingUpdates &&
                this.pendingUpdates?.map((v) => (v == undefined ? undefined : v.asObject())),
            anchor: this.anchor && this.anchor.asObject(),
            executorVersion: this.executorVersion && _1.ExecutorVersion.getName(this.executorVersion),
            bvnExecutorVersions: this.bvnExecutorVersions &&
                this.bvnExecutorVersions?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], SystemLedger.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], SystemLedger.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], SystemLedger.prototype, "index", void 0);
__decorate([
    encoding_1.encodeAs.field(4).time
], SystemLedger.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(5).bigInt
], SystemLedger.prototype, "acmeBurnt", void 0);
__decorate([
    encoding_1.encodeAs.field(6).repeatable.reference
], SystemLedger.prototype, "pendingUpdates", void 0);
__decorate([
    encoding_1.encodeAs.field(7).union
], SystemLedger.prototype, "anchor", void 0);
__decorate([
    encoding_1.encodeAs.field(8).enum
], SystemLedger.prototype, "executorVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(9).repeatable.reference
], SystemLedger.prototype, "bvnExecutorVersions", void 0);
exports.SystemLedger = SystemLedger;
class SystemWriteData {
    constructor(args) {
        this.type = _1.TransactionType.SystemWriteData;
        this.entry = args.entry == undefined ? undefined : _1.DataEntry.fromObject(args.entry);
        this.writeToState = args.writeToState == undefined ? undefined : args.writeToState;
    }
    copy() {
        return new SystemWriteData(this.asObject());
    }
    asObject() {
        return {
            type: "systemWriteData",
            entry: this.entry && this.entry.asObject(),
            writeToState: this.writeToState && this.writeToState,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], SystemWriteData.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], SystemWriteData.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bool
], SystemWriteData.prototype, "writeToState", void 0);
exports.SystemWriteData = SystemWriteData;
class TokenAccount {
    constructor(args) {
        this.type = _1.AccountType.TokenAccount;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => v == undefined ? undefined : v instanceof AuthorityEntry ? v : new AuthorityEntry(v));
        this.tokenUrl = args.tokenUrl == undefined ? undefined : url_1.AccumulateURL.parse(args.tokenUrl);
        this.balance =
            args.balance == undefined
                ? undefined
                : typeof args.balance === "bigint"
                    ? args.balance
                    : BigInt(args.balance);
    }
    copy() {
        return new TokenAccount(this.asObject());
    }
    asObject() {
        return {
            type: "tokenAccount",
            url: this.url && this.url.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.asObject())),
            tokenUrl: this.tokenUrl && this.tokenUrl.toString(),
            balance: this.balance && this.balance.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], TokenAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], TokenAccount.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).repeatable.reference
], TokenAccount.prototype, "authorities", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], TokenAccount.prototype, "tokenUrl", void 0);
__decorate([
    encoding_1.encodeAs.field(5).bigInt
], TokenAccount.prototype, "balance", void 0);
exports.TokenAccount = TokenAccount;
class TokenIssuer {
    constructor(args) {
        this.type = _1.AccountType.TokenIssuer;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => v == undefined ? undefined : v instanceof AuthorityEntry ? v : new AuthorityEntry(v));
        this.symbol = args.symbol == undefined ? undefined : args.symbol;
        this.precision = args.precision == undefined ? undefined : args.precision;
        this.properties = args.properties == undefined ? undefined : url_1.AccumulateURL.parse(args.properties);
        this.issued =
            args.issued == undefined
                ? undefined
                : typeof args.issued === "bigint"
                    ? args.issued
                    : BigInt(args.issued);
        this.supplyLimit =
            args.supplyLimit == undefined
                ? undefined
                : typeof args.supplyLimit === "bigint"
                    ? args.supplyLimit
                    : BigInt(args.supplyLimit);
    }
    copy() {
        return new TokenIssuer(this.asObject());
    }
    asObject() {
        return {
            type: "tokenIssuer",
            url: this.url && this.url.toString(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.asObject())),
            symbol: this.symbol && this.symbol,
            precision: this.precision && this.precision,
            properties: this.properties && this.properties.toString(),
            issued: this.issued && this.issued.toString(),
            supplyLimit: this.supplyLimit && this.supplyLimit.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], TokenIssuer.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], TokenIssuer.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3, 1).repeatable.reference
], TokenIssuer.prototype, "authorities", void 0);
__decorate([
    encoding_1.encodeAs.field(4).string
], TokenIssuer.prototype, "symbol", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], TokenIssuer.prototype, "precision", void 0);
__decorate([
    encoding_1.encodeAs.field(6).url
], TokenIssuer.prototype, "properties", void 0);
__decorate([
    encoding_1.encodeAs.field(7).bigInt
], TokenIssuer.prototype, "issued", void 0);
__decorate([
    encoding_1.encodeAs.field(8).bigInt
], TokenIssuer.prototype, "supplyLimit", void 0);
exports.TokenIssuer = TokenIssuer;
class TokenIssuerProof {
    constructor(args) {
        this.transaction =
            args.transaction == undefined
                ? undefined
                : args.transaction instanceof CreateToken
                    ? args.transaction
                    : new CreateToken(args.transaction);
        this.receipt =
            args.receipt == undefined
                ? undefined
                : args.receipt instanceof merkle.Receipt
                    ? args.receipt
                    : new merkle.Receipt(args.receipt);
    }
    copy() {
        return new TokenIssuerProof(this.asObject());
    }
    asObject() {
        return {
            transaction: this.transaction && this.transaction.asObject(),
            receipt: this.receipt && this.receipt.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], TokenIssuerProof.prototype, "transaction", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], TokenIssuerProof.prototype, "receipt", void 0);
exports.TokenIssuerProof = TokenIssuerProof;
class TokenRecipient {
    constructor(args) {
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.amount =
            args.amount == undefined
                ? undefined
                : typeof args.amount === "bigint"
                    ? args.amount
                    : BigInt(args.amount);
    }
    copy() {
        return new TokenRecipient(this.asObject());
    }
    asObject() {
        return {
            url: this.url && this.url.toString(),
            amount: this.amount && this.amount.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], TokenRecipient.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bigInt
], TokenRecipient.prototype, "amount", void 0);
exports.TokenRecipient = TokenRecipient;
class Transaction extends base_1.TransactionBase {
    constructor(args) {
        super();
        this.header =
            args.header == undefined
                ? undefined
                : args.header instanceof TransactionHeader
                    ? args.header
                    : new TransactionHeader(args.header);
        this.body = args.body == undefined ? undefined : _1.TransactionBody.fromObject(args.body);
    }
    copy() {
        return new Transaction(this.asObject());
    }
    asObject() {
        return {
            header: this.header && this.header.asObject(),
            body: this.body && this.body.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).reference
], Transaction.prototype, "header", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], Transaction.prototype, "body", void 0);
exports.Transaction = Transaction;
class TransactionHeader {
    constructor(args) {
        this.principal = args.principal == undefined ? undefined : url_1.AccumulateURL.parse(args.principal);
        this.initiator =
            args.initiator == undefined
                ? undefined
                : args.initiator instanceof Uint8Array
                    ? args.initiator
                    : buffer_1.Buffer.from(args.initiator, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.metadata =
            args.metadata == undefined
                ? undefined
                : args.metadata instanceof Uint8Array
                    ? args.metadata
                    : buffer_1.Buffer.from(args.metadata, "hex");
        this.expire =
            args.expire == undefined
                ? undefined
                : args.expire instanceof ExpireOptions
                    ? args.expire
                    : new ExpireOptions(args.expire);
        this.holdUntil =
            args.holdUntil == undefined
                ? undefined
                : args.holdUntil instanceof HoldUntilOptions
                    ? args.holdUntil
                    : new HoldUntilOptions(args.holdUntil);
        this.authorities =
            args.authorities == undefined
                ? undefined
                : args.authorities.map((v) => (v == undefined ? undefined : url_1.AccumulateURL.parse(v)));
    }
    copy() {
        return new TransactionHeader(this.asObject());
    }
    asObject() {
        return {
            principal: this.principal && this.principal.toString(),
            initiator: this.initiator && this.initiator && buffer_1.Buffer.from(this.initiator).toString("hex"),
            memo: this.memo && this.memo,
            metadata: this.metadata && this.metadata && buffer_1.Buffer.from(this.metadata).toString("hex"),
            expire: this.expire && this.expire.asObject(),
            holdUntil: this.holdUntil && this.holdUntil.asObject(),
            authorities: this.authorities &&
                this.authorities?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).url
], TransactionHeader.prototype, "principal", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], TransactionHeader.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(3).string
], TransactionHeader.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bytes
], TransactionHeader.prototype, "metadata", void 0);
__decorate([
    encoding_1.encodeAs.field(5).reference
], TransactionHeader.prototype, "expire", void 0);
__decorate([
    encoding_1.encodeAs.field(6).reference
], TransactionHeader.prototype, "holdUntil", void 0);
__decorate([
    encoding_1.encodeAs.field(7).repeatable.url
], TransactionHeader.prototype, "authorities", void 0);
exports.TransactionHeader = TransactionHeader;
class TransactionStatus {
    constructor(args) {
        this.txID = args.txID == undefined ? undefined : txid_1.AccumulateTxID.parse(args.txID);
        this.code = args.code == undefined ? undefined : errors2.Status.fromObject(args.code);
        this.error =
            args.error == undefined
                ? undefined
                : args.error instanceof errors2.Error
                    ? args.error
                    : new errors2.Error(args.error);
        this.result = args.result == undefined ? undefined : _1.TransactionResult.fromObject(args.result);
        this.received = args.received == undefined ? undefined : args.received;
        this.initiator = args.initiator == undefined ? undefined : url_1.AccumulateURL.parse(args.initiator);
        this.signers =
            args.signers == undefined
                ? undefined
                : args.signers.map((v) => (v == undefined ? undefined : _1.Signer.fromObject(v)));
        this.sourceNetwork =
            args.sourceNetwork == undefined ? undefined : url_1.AccumulateURL.parse(args.sourceNetwork);
        this.destinationNetwork =
            args.destinationNetwork == undefined ? undefined : url_1.AccumulateURL.parse(args.destinationNetwork);
        this.sequenceNumber = args.sequenceNumber == undefined ? undefined : args.sequenceNumber;
        this.gotDirectoryReceipt =
            args.gotDirectoryReceipt == undefined ? undefined : args.gotDirectoryReceipt;
        this.proof =
            args.proof == undefined
                ? undefined
                : args.proof instanceof merkle.Receipt
                    ? args.proof
                    : new merkle.Receipt(args.proof);
        this.anchorSigners =
            args.anchorSigners == undefined
                ? undefined
                : args.anchorSigners.map((v) => v == undefined ? undefined : v instanceof Uint8Array ? v : buffer_1.Buffer.from(v, "hex"));
    }
    copy() {
        return new TransactionStatus(this.asObject());
    }
    asObject() {
        return {
            txID: this.txID && this.txID.toString(),
            code: this.code && errors2.Status.getName(this.code),
            error: this.error && this.error.asObject(),
            result: this.result && this.result.asObject(),
            received: this.received && this.received,
            initiator: this.initiator && this.initiator.toString(),
            signers: this.signers && this.signers?.map((v) => (v == undefined ? undefined : v.asObject())),
            sourceNetwork: this.sourceNetwork && this.sourceNetwork.toString(),
            destinationNetwork: this.destinationNetwork && this.destinationNetwork.toString(),
            sequenceNumber: this.sequenceNumber && this.sequenceNumber,
            gotDirectoryReceipt: this.gotDirectoryReceipt && this.gotDirectoryReceipt,
            proof: this.proof && this.proof.asObject(),
            anchorSigners: this.anchorSigners &&
                this.anchorSigners?.map((v) => v == undefined ? undefined : v && buffer_1.Buffer.from(v).toString("hex")),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).txid
], TransactionStatus.prototype, "txID", void 0);
__decorate([
    encoding_1.encodeAs.field(2).enum
], TransactionStatus.prototype, "code", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], TransactionStatus.prototype, "error", void 0);
__decorate([
    encoding_1.encodeAs.field(4).union
], TransactionStatus.prototype, "result", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], TransactionStatus.prototype, "received", void 0);
__decorate([
    encoding_1.encodeAs.field(6).url
], TransactionStatus.prototype, "initiator", void 0);
__decorate([
    encoding_1.encodeAs.field(7).repeatable.union
], TransactionStatus.prototype, "signers", void 0);
__decorate([
    encoding_1.encodeAs.field(8).url
], TransactionStatus.prototype, "sourceNetwork", void 0);
__decorate([
    encoding_1.encodeAs.field(9).url
], TransactionStatus.prototype, "destinationNetwork", void 0);
__decorate([
    encoding_1.encodeAs.field(10).uint
], TransactionStatus.prototype, "sequenceNumber", void 0);
__decorate([
    encoding_1.encodeAs.field(11).bool
], TransactionStatus.prototype, "gotDirectoryReceipt", void 0);
__decorate([
    encoding_1.encodeAs.field(12).reference
], TransactionStatus.prototype, "proof", void 0);
__decorate([
    encoding_1.encodeAs.field(13).repeatable.bytes
], TransactionStatus.prototype, "anchorSigners", void 0);
exports.TransactionStatus = TransactionStatus;
class TransferCredits {
    constructor(args) {
        this.type = _1.TransactionType.TransferCredits;
        this.to =
            args.to == undefined
                ? undefined
                : args.to.map((v) => v == undefined ? undefined : v instanceof CreditRecipient ? v : new CreditRecipient(v));
    }
    copy() {
        return new TransferCredits(this.asObject());
    }
    asObject() {
        return {
            type: "transferCredits",
            to: this.to && this.to?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], TransferCredits.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.reference
], TransferCredits.prototype, "to", void 0);
exports.TransferCredits = TransferCredits;
class TxIdSet {
    constructor(args) {
        this.entries =
            args.entries == undefined
                ? undefined
                : args.entries.map((v) => (v == undefined ? undefined : txid_1.AccumulateTxID.parse(v)));
    }
    copy() {
        return new TxIdSet(this.asObject());
    }
    asObject() {
        return {
            entries: this.entries && this.entries?.map((v) => (v == undefined ? undefined : v.toString())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).repeatable.txid
], TxIdSet.prototype, "entries", void 0);
exports.TxIdSet = TxIdSet;
class TypedDataSignature {
    constructor(args) {
        this.type = _1.SignatureType.TypedData;
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.signature =
            args.signature == undefined
                ? undefined
                : args.signature instanceof Uint8Array
                    ? args.signature
                    : buffer_1.Buffer.from(args.signature, "hex");
        this.signer = args.signer == undefined ? undefined : url_1.AccumulateURL.parse(args.signer);
        this.signerVersion = args.signerVersion == undefined ? undefined : args.signerVersion;
        this.timestamp = args.timestamp == undefined ? undefined : args.timestamp;
        this.vote = args.vote == undefined ? undefined : _1.VoteType.fromObject(args.vote);
        this.transactionHash =
            args.transactionHash == undefined
                ? undefined
                : args.transactionHash instanceof Uint8Array
                    ? args.transactionHash
                    : buffer_1.Buffer.from(args.transactionHash, "hex");
        this.memo = args.memo == undefined ? undefined : args.memo;
        this.data =
            args.data == undefined
                ? undefined
                : args.data instanceof Uint8Array
                    ? args.data
                    : buffer_1.Buffer.from(args.data, "hex");
        this.chainID =
            args.chainID == undefined
                ? undefined
                : typeof args.chainID === "bigint"
                    ? args.chainID
                    : BigInt(args.chainID);
    }
    copy() {
        return new TypedDataSignature(this.asObject());
    }
    asObject() {
        return {
            type: "typedData",
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            signature: this.signature && this.signature && buffer_1.Buffer.from(this.signature).toString("hex"),
            signer: this.signer && this.signer.toString(),
            signerVersion: this.signerVersion && this.signerVersion,
            timestamp: this.timestamp && this.timestamp,
            vote: this.vote && _1.VoteType.getName(this.vote),
            transactionHash: this.transactionHash &&
                this.transactionHash &&
                buffer_1.Buffer.from(this.transactionHash).toString("hex"),
            memo: this.memo && this.memo,
            data: this.data && this.data && buffer_1.Buffer.from(this.data).toString("hex"),
            chainID: this.chainID && this.chainID.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.SignatureType)
], TypedDataSignature.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], TypedDataSignature.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bytes
], TypedDataSignature.prototype, "signature", void 0);
__decorate([
    encoding_1.encodeAs.field(4).url
], TypedDataSignature.prototype, "signer", void 0);
__decorate([
    encoding_1.encodeAs.field(5).uint
], TypedDataSignature.prototype, "signerVersion", void 0);
__decorate([
    encoding_1.encodeAs.field(6).uint
], TypedDataSignature.prototype, "timestamp", void 0);
__decorate([
    encoding_1.encodeAs.field(7).enum
], TypedDataSignature.prototype, "vote", void 0);
__decorate([
    encoding_1.encodeAs.field(8).hash
], TypedDataSignature.prototype, "transactionHash", void 0);
__decorate([
    encoding_1.encodeAs.field(9).string
], TypedDataSignature.prototype, "memo", void 0);
__decorate([
    encoding_1.encodeAs.field(10).bytes
], TypedDataSignature.prototype, "data", void 0);
__decorate([
    encoding_1.encodeAs.field(11).bigInt
], TypedDataSignature.prototype, "chainID", void 0);
exports.TypedDataSignature = TypedDataSignature;
class UnknownAccount {
    constructor(args) {
        this.type = _1.AccountType.Unknown;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
    }
    copy() {
        return new UnknownAccount(this.asObject());
    }
    asObject() {
        return {
            type: "unknown",
            url: this.url && this.url.toString(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], UnknownAccount.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], UnknownAccount.prototype, "url", void 0);
exports.UnknownAccount = UnknownAccount;
class UnknownSigner {
    constructor(args) {
        this.type = _1.AccountType.UnknownSigner;
        this.url = args.url == undefined ? undefined : url_1.AccumulateURL.parse(args.url);
        this.version = args.version == undefined ? undefined : args.version;
    }
    copy() {
        return new UnknownSigner(this.asObject());
    }
    asObject() {
        return {
            type: "unknownSigner",
            url: this.url && this.url.toString(),
            version: this.version && this.version,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.AccountType)
], UnknownSigner.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], UnknownSigner.prototype, "url", void 0);
__decorate([
    encoding_1.encodeAs.field(3).uint
], UnknownSigner.prototype, "version", void 0);
exports.UnknownSigner = UnknownSigner;
class UpdateAccountAuth {
    constructor(args) {
        this.type = _1.TransactionType.UpdateAccountAuth;
        this.operations =
            args.operations == undefined
                ? undefined
                : args.operations.map((v) => v == undefined ? undefined : _1.AccountAuthOperation.fromObject(v));
    }
    copy() {
        return new UpdateAccountAuth(this.asObject());
    }
    asObject() {
        return {
            type: "updateAccountAuth",
            operations: this.operations && this.operations?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], UpdateAccountAuth.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.union
], UpdateAccountAuth.prototype, "operations", void 0);
exports.UpdateAccountAuth = UpdateAccountAuth;
class UpdateAllowedKeyPageOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.UpdateAllowed;
        this.allow =
            args.allow == undefined
                ? undefined
                : args.allow.map((v) => (v == undefined ? undefined : _1.TransactionType.fromObject(v)));
        this.deny =
            args.deny == undefined
                ? undefined
                : args.deny.map((v) => (v == undefined ? undefined : _1.TransactionType.fromObject(v)));
    }
    copy() {
        return new UpdateAllowedKeyPageOperation(this.asObject());
    }
    asObject() {
        return {
            type: "updateAllowed",
            allow: this.allow &&
                this.allow?.map((v) => (v == undefined ? undefined : _1.TransactionType.getName(v))),
            deny: this.deny &&
                this.deny?.map((v) => (v == undefined ? undefined : _1.TransactionType.getName(v))),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], UpdateAllowedKeyPageOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.enum
], UpdateAllowedKeyPageOperation.prototype, "allow", void 0);
__decorate([
    encoding_1.encodeAs.field(3).repeatable.enum
], UpdateAllowedKeyPageOperation.prototype, "deny", void 0);
exports.UpdateAllowedKeyPageOperation = UpdateAllowedKeyPageOperation;
class UpdateKey {
    constructor(args) {
        this.type = _1.TransactionType.UpdateKey;
        this.newKeyHash =
            args.newKeyHash == undefined
                ? undefined
                : args.newKeyHash instanceof Uint8Array
                    ? args.newKeyHash
                    : buffer_1.Buffer.from(args.newKeyHash, "hex");
    }
    copy() {
        return new UpdateKey(this.asObject());
    }
    asObject() {
        return {
            type: "updateKey",
            newKeyHash: this.newKeyHash && this.newKeyHash && buffer_1.Buffer.from(this.newKeyHash).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], UpdateKey.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).bytes
], UpdateKey.prototype, "newKeyHash", void 0);
exports.UpdateKey = UpdateKey;
class UpdateKeyOperation {
    constructor(args) {
        this.type = _1.KeyPageOperationType.Update;
        this.oldEntry =
            args.oldEntry == undefined
                ? undefined
                : args.oldEntry instanceof KeySpecParams
                    ? args.oldEntry
                    : new KeySpecParams(args.oldEntry);
        this.newEntry =
            args.newEntry == undefined
                ? undefined
                : args.newEntry instanceof KeySpecParams
                    ? args.newEntry
                    : new KeySpecParams(args.newEntry);
    }
    copy() {
        return new UpdateKeyOperation(this.asObject());
    }
    asObject() {
        return {
            type: "update",
            oldEntry: this.oldEntry && this.oldEntry.asObject(),
            newEntry: this.newEntry && this.newEntry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.KeyPageOperationType)
], UpdateKeyOperation.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).reference
], UpdateKeyOperation.prototype, "oldEntry", void 0);
__decorate([
    encoding_1.encodeAs.field(3).reference
], UpdateKeyOperation.prototype, "newEntry", void 0);
exports.UpdateKeyOperation = UpdateKeyOperation;
class UpdateKeyPage {
    constructor(args) {
        this.type = _1.TransactionType.UpdateKeyPage;
        this.operation =
            args.operation == undefined
                ? undefined
                : args.operation.map((v) => (v == undefined ? undefined : _1.KeyPageOperation.fromObject(v)));
    }
    copy() {
        return new UpdateKeyPage(this.asObject());
    }
    asObject() {
        return {
            type: "updateKeyPage",
            operation: this.operation && this.operation?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], UpdateKeyPage.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).repeatable.union
], UpdateKeyPage.prototype, "operation", void 0);
exports.UpdateKeyPage = UpdateKeyPage;
class ValidatorInfo {
    constructor(args) {
        this.publicKey =
            args.publicKey == undefined
                ? undefined
                : args.publicKey instanceof Uint8Array
                    ? args.publicKey
                    : buffer_1.Buffer.from(args.publicKey, "hex");
        this.publicKeyHash =
            args.publicKeyHash == undefined
                ? undefined
                : args.publicKeyHash instanceof Uint8Array
                    ? args.publicKeyHash
                    : buffer_1.Buffer.from(args.publicKeyHash, "hex");
        this.operator = args.operator == undefined ? undefined : url_1.AccumulateURL.parse(args.operator);
        this.partitions =
            args.partitions == undefined
                ? undefined
                : args.partitions.map((v) => v == undefined
                    ? undefined
                    : v instanceof ValidatorPartitionInfo
                        ? v
                        : new ValidatorPartitionInfo(v));
    }
    copy() {
        return new ValidatorInfo(this.asObject());
    }
    asObject() {
        return {
            publicKey: this.publicKey && this.publicKey && buffer_1.Buffer.from(this.publicKey).toString("hex"),
            publicKeyHash: this.publicKeyHash && this.publicKeyHash && buffer_1.Buffer.from(this.publicKeyHash).toString("hex"),
            operator: this.operator && this.operator.toString(),
            partitions: this.partitions && this.partitions?.map((v) => (v == undefined ? undefined : v.asObject())),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).bytes
], ValidatorInfo.prototype, "publicKey", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], ValidatorInfo.prototype, "publicKeyHash", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], ValidatorInfo.prototype, "operator", void 0);
__decorate([
    encoding_1.encodeAs.field(4).repeatable.reference
], ValidatorInfo.prototype, "partitions", void 0);
exports.ValidatorInfo = ValidatorInfo;
class ValidatorPartitionInfo {
    constructor(args) {
        this.id = args.id == undefined ? undefined : args.id;
        this.active = args.active == undefined ? undefined : args.active;
    }
    copy() {
        return new ValidatorPartitionInfo(this.asObject());
    }
    asObject() {
        return {
            id: this.id && this.id,
            active: this.active && this.active,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).string
], ValidatorPartitionInfo.prototype, "id", void 0);
__decorate([
    encoding_1.encodeAs.field(2).keepEmpty.bool
], ValidatorPartitionInfo.prototype, "active", void 0);
exports.ValidatorPartitionInfo = ValidatorPartitionInfo;
class WriteData {
    constructor(args) {
        this.type = _1.TransactionType.WriteData;
        this.entry = args.entry == undefined ? undefined : _1.DataEntry.fromObject(args.entry);
        this.scratch = args.scratch == undefined ? undefined : args.scratch;
        this.writeToState = args.writeToState == undefined ? undefined : args.writeToState;
    }
    copy() {
        return new WriteData(this.asObject());
    }
    asObject() {
        return {
            type: "writeData",
            entry: this.entry && this.entry.asObject(),
            scratch: this.scratch && this.scratch,
            writeToState: this.writeToState && this.writeToState,
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], WriteData.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).union
], WriteData.prototype, "entry", void 0);
__decorate([
    encoding_1.encodeAs.field(3).bool
], WriteData.prototype, "scratch", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bool
], WriteData.prototype, "writeToState", void 0);
exports.WriteData = WriteData;
class WriteDataResult {
    constructor(args) {
        this.type = _1.TransactionType.WriteData;
        this.entryHash =
            args.entryHash == undefined
                ? undefined
                : args.entryHash instanceof Uint8Array
                    ? args.entryHash
                    : buffer_1.Buffer.from(args.entryHash, "hex");
        this.accountUrl = args.accountUrl == undefined ? undefined : url_1.AccumulateURL.parse(args.accountUrl);
        this.accountID =
            args.accountID == undefined
                ? undefined
                : args.accountID instanceof Uint8Array
                    ? args.accountID
                    : buffer_1.Buffer.from(args.accountID, "hex");
    }
    copy() {
        return new WriteDataResult(this.asObject());
    }
    asObject() {
        return {
            type: "writeData",
            entryHash: this.entryHash && this.entryHash && buffer_1.Buffer.from(this.entryHash).toString("hex"),
            accountUrl: this.accountUrl && this.accountUrl.toString(),
            accountID: this.accountID && this.accountID && buffer_1.Buffer.from(this.accountID).toString("hex"),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], WriteDataResult.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).hash
], WriteDataResult.prototype, "entryHash", void 0);
__decorate([
    encoding_1.encodeAs.field(3).url
], WriteDataResult.prototype, "accountUrl", void 0);
__decorate([
    encoding_1.encodeAs.field(4).bytes
], WriteDataResult.prototype, "accountID", void 0);
exports.WriteDataResult = WriteDataResult;
class WriteDataTo {
    constructor(args) {
        this.type = _1.TransactionType.WriteDataTo;
        this.recipient = args.recipient == undefined ? undefined : url_1.AccumulateURL.parse(args.recipient);
        this.entry = args.entry == undefined ? undefined : _1.DataEntry.fromObject(args.entry);
    }
    copy() {
        return new WriteDataTo(this.asObject());
    }
    asObject() {
        return {
            type: "writeDataTo",
            recipient: this.recipient && this.recipient.toString(),
            entry: this.entry && this.entry.asObject(),
        };
    }
}
__decorate([
    encoding_1.encodeAs.field(1).keepEmpty.enum.of(_1.TransactionType)
], WriteDataTo.prototype, "type", void 0);
__decorate([
    encoding_1.encodeAs.field(2).url
], WriteDataTo.prototype, "recipient", void 0);
__decorate([
    encoding_1.encodeAs.field(3).union
], WriteDataTo.prototype, "entry", void 0);
exports.WriteDataTo = WriteDataTo;
//# sourceMappingURL=types_gen.js.map